import {
  IDocId2InsightsVariables,
  ISearchPoiVariables,
  IDocId2InsightsResponse,
  IDocId2InformationResponse,
  IDocId2InformationVariables,
  User,
  IVerifyResetPasswordRequestVariables,
  IVerifyResetPasswordRequestResponse,
  CommutePreference,
  IPoiByIdsVariables,
  IPoiByIdsResponse,
  IProject,
  IBulletin,
  IPoiIdentifier,
  DatedPoi,
  ILocalPageResponse,
  InsightDescriptor,
  IReference,
  IUpdateSaveSearchResponse,
  IDeleteSaveSearchResponse,
  ILHomePageSearchTemporaryInterface,
  ILocalPageVariables,
  Priority,
  PoiId,
  IAd,
  DealType,
  UserSavedAddresses,
  IUploadBulletinInput,
  BulletinStatusType,
  IImageItem,
  IDataLayerItem,
  ILocalPagePreviewResponse,
  ITileRange,
  DataLayerPoiType,
  IDeal,
  IDocId2InfoUnitResponse,
  IClusterDataLayer,
  ISearchParametersWithoutSort,
  IDataLayer,
  PurchasingReason,
  IDocIds2InformationVariables,
  IDocIds2InformationResponse,
  IAutocompleteEntry,
  MadadDto,
  PoiType,
  ISearchLocalAddressPageResponse,
  IBannersByDocIdVariables,
  BannersByDocIdResponse,
  ITabuByDocIdVariables,
  TabuByDocIdResponse,
  IFooterByDocIdVariables,
  FooterByDocIdResponse,
  IUpdateListingInput,
  MadadParticipantsResponse,
  IMadadParticipantsVariables,
  IMadadAgentsOfficesVariables,
  MadadAgentsOfficesResponse,
  IMadadWinnersBannersByDocIdVariables,
  MadadWinnersBannersByDocIdResponse,
  ICommercialBulletin,
  ICommercialProject,
  IUpdateListingStatusInput,
  ListingStatusType,
  IEditListingPoiByIdsVariables,
  IUpdateCommercialListingInput,
  IUploadCommercialBulletinInput,
  IEditAssignedAgentCommercialListingInput,
  IEditCommercialListingPromotionStatusVariables,
  IAgentsOfOfficeByIdVariables,
  IAdminSearchVariables,
  IMadadWinnersBannersForStreetByDocIdVariables,
  IDeveloperProfile,
  ContactDeveloperReason,
  ICommercialLocalInfoResponse,
  Area,
  IOfficePageData,
  ITeamByOfficeIdData,
  IMortgageOffice,
  IAgentPageData,
  IAgentOfficeBulletinsData,
  RealEstateLevel,
  IOfficeAgentDisplayLevel,
  DeviceType,
  MarketplaceType,
  AwardCategories,
  Award,
  IAgentWithBulletinsData,
  LeadingAgentFeature,
  IOfficeData,
  IDealAffiliationRequest,
  ISearchDeal,
  ISearchNumberRange,
  ISearchDateRange,
  IAffiliationRequestResponseDeal,
  DealAffiliationType,
  IRequestDealAffiliationResponse,
  ICommercialListing,
  IEditListingPromotionStatusVariables,
  IEditAssignedAgentListingInput,
  IBaseAutocompleteDoc,
  LoginResponseNG,
  ResetPasswordStatus,
  IOfficeByIdData,
  IStaffMember,
  IPublicRealEstateAgent,
  ISpotlightListing,
  IRealEstateVideoSource,
  IRealEstateAgentTestimonial,
  AutocompleteDocumentUnion,
  INeighbourhoodCrimeRateLevel,
  ICrimeHistoryDataPoint,
  IDealsNumTrendsListItem,
  IPriceTrendsListItem,
  IBuildingRequest,
  ListingSearchData,
  INeighborhoodPublicInsightsVariables,
  INeighborhoodPublicInsightsResponse,
  IUnitsByYear,
  IAutocompleteNeighbourhood,
  ISearch,
  IUserPaymentTransactionVariables,
  IUserPaymentTransactionsVariables,
  SecureRoomType,
  ProfessionalUserRole,
} from 'utils/entities';
import { ISOString } from 'locale/formatDate';
import { FetchPolicy, ErrorPolicy } from 'apollo-client';
import { SourceType } from 'components/expanded-highlights-page/types';
import { UpdateFrequency } from 'components/saved-search/config';
import {
  Condition,
  Amenity,
  RangeTuple,
  PropertyType,
  RoomOption,
  Seller,
  BathOption,
} from 'components/filters/types';
import { FetchResult } from 'apollo-link';
import { GraphQLError } from 'graphql';
import { FeedbackPopupType } from 'components/common-feedback-popup-view/utils';
import { Topic, RatingTopic } from 'components/user-generated-content/utils/initialUGCConfig';
import { AuthModalSource, ContactAgentModalSource } from 'store/state/app';
import { MultiPolygon } from 'geojson';
import { UploadBulletinReportSource } from 'components/upload-bulletin/report-error-popup/interfaces';
import { SocialVendor } from 'components/authentication/types';
import { TranzilaPaymentMethod } from 'components/tranzila-hosted-fields/types';

export enum MoveIn {
  Looking = 'onlyLooking',
  NotInAHurry = 'notInAHurry',
  Now = 'now',
}

export type MutationResponse<T extends MutationType> = FetchResult<MutationResponseByType[T]> & {
  errors?: IError[];
};

export enum LoadType {
  GetProfessionalUserInfo = 'getProfessionalUserInfo',
  FavoriteNeighborhoods = 'favoriteNeighborhoods',
  AddressSearch = 'addressSearch',
  SchoolSearch = 'schoolSearch',
  SchoolByLocation = 'schoolByLocation',
  StreetSearch = 'streetSearch',
  SearchList = 'searchList',
  ProjectsSearchResultList = 'projectsSearchResultList',
  SearchMapClusters = 'searchMapClusters',
  SearchMapListings = 'searchMapListings',
  AddressesByDocIds = 'addressesByDocIds',
  SearchMapDataLayers = 'searchMapLayers',
  SearchMapDataLayersV3 = 'searchMapDataLayersV3',
  Insights = 'insights',
  MixedApiInsights = 'mixedApiInsights',
  NeighborhoodPublicInsights = 'neighborhoodPublicInsights',
  CurrentUser = 'currentUser',
  CurrentUserSearchHistory = 'currentUserSearchHistory',
  VerifyResetPasswordRequest = 'verifyResetPasswordRequest',
  SearchDoc = 'searchDoc',
  AddressDoc = 'addressDoc',
  LocalDoc = 'localDoc',
  BusRouteByIds = 'busRouteByIds',
  LocalDocPreview = 'localDocPreview',
  StrictLocalDoc = 'strictLocalDoc', // required for ads, populated after local page docId2Information returns the
                                     // strict location boundary
  CommercialLocalInfo = 'commercialLocalInfo',
  AreasWithCommercialInfoPage = 'areasWithCommercialInfoPage',
  UnitPageBulletin = 'bulletinsByIds',
  UnitPageCommercialBulletin = 'commercialBulletinsByIds',
  MapPreview = 'mapPreview',
  MapMultiPreview = 'mapMultiPreview',
  ProjectPageProject = 'projectsByIds',
  ProjectPageCommercialProject = 'projectPageCommercialProject',
  ShortlistPois = 'shortlistPois',
  FavoritesPois = 'favoritesPois',
  IlHomePageBulletins = 'ilHomePageBulletins',
  SearchBySearchId = 'searchBySearchId',
  UserListings = 'usersListings',
  SearchByUserIdAndSearchId = 'getSearchByUserIdAndSearchId',
  UserAllListings = 'usersAllListings',
  LocalData = 'localData',
  SearchHistoryNotifications = 'searchHistoryNotifications',
  SavedSearchesNotifications = 'savedSearchesNotifications',
  Deal = 'Deal',
  SearchProjectList = 'searchProjectList',
  StrictUnitDoc = 'strictUnitDoc',
  UserContent = 'userContent',
  UserContentTextReviews = 'userContentTextReviews',
  UserContentRatingReviews = 'userContentRatingReviews',
  Madad = 'madad',
  MadadAgentsOffices = 'madadAgentsOffices',
  MadadSearchAgentsOffices = 'searchMadadAgentsOffices',
  BannersByDocId = 'bannersByDocId',
  SearchPageBannersByDocId = 'searchPageBannersByDocId',
  AdditionalBannersByDocId = 'additionalBannersByDocId',
  MadadWinnersBannersByDocId = 'madadWinnersBannersByDocId',
  MadadWinnersBannersForStreetByDocId = 'madadWinnersBannersForStreetByDocId',
  MadadWinnersExistForDocId = 'madadWinnersExistForDocId',
  MadadWinnersExistForStreetForDocId = 'madadWinnersExistForStreetForDocId',
  SearchLocalAddressPage = 'searchLocalAddressPage',
  Tabu = 'Tabu',
  FooterByDocId = 'FooterByDocId',
  MadadParticipants = 'madadParticipants',
  HomePageBanner = 'homePageBanner',
  EditListingPoi = 'editListingPoi',
  MadadAgentBanner = 'MadadAgentBanner',
  AgentsOfOfficeById = 'agentsOfOfficeById',
  AdminSearch = 'adminSearch',
  ProjectMapLogo = 'projectMapLogo',
  IsPhoneRegistered = 'isPhoneRegistered',
  DeveloperById = 'developerById',
  SearchDevelopers = 'searchDevelopers',
  OfficeById = 'officeById',
  OfficeDataById = 'officeDataById',
  GetOfficeListings = 'getOfficeListings',
  OfficeBulletinsById = 'officeBulletinsById',
  AgentById = 'agentById',
  AgentWithBulletinsById = 'agentWithBulletinsById',
  AgentContactInfoById = 'agentContactInfoById',
  AgentBulletinsById = 'agentBulletinsById',
  TeamByOfficeId = 'teamByOfficeId',
  SchoolByIdQuery = 'schoolById',
  AdditionalCarouselSearch = 'additionalCarouselSearch',
  ListingPostLeadCarouselSearch = 'listingPostLeadCarouselSearch',
  MortgageOfficesByCityDocIds = 'mortgageOfficesByCityDocIds',
  MortgageOfficeById = 'mortgageOfficeById',
  DevelopersAndPromotedProjects = 'developersAndPromotedProjects',
  UserNotificationDevices = 'userNotificationDevices',
  SearchAwardsByIds = 'searchAwardsByIds',
  GetUnitPageLeadingData = 'getUnitPageLeadingData',
  SearchAwardsByDocIds = 'searchAwardsByDocIds',
  FeaturedMortgageOffice = 'featuredMortgageOffice',
  GetDealsAffiliationRequests = 'getDealsAffiliationRequests',
  SearchDeals = 'searchDeals',
  GetDealAffiliationRequestsBySaleId = 'getDealAffiliationRequestBySaleId',
  GetCommercialListing = 'getCommercialListing',
  GetResidentialListing = 'getResidentialListing',
  GetResidentialAndCommercialListings = 'getResidentialAndCommercialListings',
  GetBulletinsUsageOverview = 'getBulletinsUsageOverview',
  GetPublicRealEstateOfficesByIds = 'getPublicRealEstateOfficesByIds',
  GetPublicRealEstateAgentsByIds = 'getPublicRealEstateAgentsByIds',
  GetPublicRealEstateOfficeById = 'getPublicRealEstateOfficeById',
  GetPublicRealEstateAgentById = 'getPublicRealEstateAgentById',
  CurrentPromotionPlan = 'currentPromotionPlan',
  UserCurrentPromotionPlan = 'userCurrentPromotionPlan',
  ActivePromotionPlans = 'activePromotionPlans',
  GetAgentOrOfficeSummary = 'getAgentOrOfficeSummary',
  NeighbourhoodInvestorSummary = 'neighbourhoodInvestorSummary',
  ComparedNeighbourhoodInvestorSummary = 'comparedNeighbourhoodInvestorSummary',
  InvestorMarketStats = 'investorMarketStats',
  InvestorNationalSalesHistory = 'investorNationalSalesHistory',
  InvestorPopularListingsOnePerCity = 'investorPopularListingsOnePerCity',
  InvestorSuggestedListings = 'investorSuggestedListings',
  InvestorBulletinsWithPriceDrop = 'investorBulletinsWithPriceDrop',
  InvestorHighRentYieldNeighborhoods = 'investorHighRentYieldNeighborhoods',
  InvestorNeighborhoodsWithGrowthPotential = 'investorNeighborhoodsWithGrowthPotential',
  InvestorHighRentYieldUserPreferencesNeighborhoods = 'investorHighRentYieldUserPreferencesNeighborhoods',
  InvestorUserPreferencesNeighborhoodsWithGrowthPotential = 'investorUserPreferencesNeighborhoodsWithGrowthPotential',
  InvestorPreferences = 'investorPreferences',
  InvestorCalculatedInvestorBudget = 'investorCalculatedInvestorBudget',
  InvestorSuggestedNeighborhoods = 'investorSuggestedNeighborhoods',
  NeighbourhoodInvestorPriceTrendsInsight = 'neighbourhoodInvestorPriceTrendsInsight',
  ComparedNeighbourhoodInvestorPriceTrendsInsight = 'comparedNeighbourhoodInvestorPriceTrendsInsight',
  ListingSearchData = 'listingSearchData',
  InvestorRecentSearches = 'investorRecentSearches',
  InvestorMatchedListingsCount = 'investorMatchedListingsCount',
  InvestorSimilarNeighbourhoods = 'investorSimilarNeighbourhoods',
  HomepageLastSearchListings = 'homepageLastSearchListings',
  UserPaymentTransaction = 'userPaymentTransaction',
  UserPaymentTransactions = 'userPaymentTransactions',
}

export interface ILocalDataVariables {
  docId: string;
}

export enum UserTypeCommercial {
  user = 'USER',
  agent = 'AGENT',
}

export interface IUserListingsVariables {
  userToken?: string;
  includeResidential?: boolean;
  usersIds?: string[];
  userType?: UserTypeCommercial;
  timestamp?: number;
  offset?: number;
  limit?: number;
}

export interface IUserContentVariables {
  docId: string;
  userToken: string;
}

export interface IUserContentTextReviewsVariables {
  docId: string;
}

export interface IUserContentRatingReviewsVariables {
  docId: string;
}

interface IStandartDataLayerQuery {
  dataLayerType: DataLayerPoiType;
  query: null;
}

interface IListingsDataLayerQuery {
  dataLayerType: 'listingCluster';
  query: ISearchParametersWithoutSort;
}

type DataLayerQuery = IStandartDataLayerQuery | IListingsDataLayerQuery;

export interface IDataLayersVariables {
  tileRanges: ITileRange[];
  tileRangesExcl?: ITileRange[];
  zoom: number;
  dataLayerQuery: DataLayerQuery[];
  withTransportationAPI3?: boolean;
}

export interface IMadadVariables {
  userToken?: string;
}

export interface IHPBannerVariables {
  userToken?: string;
  useTimestamp?: boolean;
}

export interface IProjectMapLogoVariables {
  userToken?: string;
}

export interface ICommercialLocalInfoVariables {
  docId: string;
}

export interface IPhoneRegisteredVariables {
  userToken?: string;
  phoneNumber: string;
}

export interface IGenerateValidationCodeVariables {
  phoneNumber: string;
}

export interface ICheckValidationCodeVariables {
  phoneNumber: string;
  code: string;
}

export interface IDeveloperByIdVariables {
  id: string;
}
export interface IOfficeByIdVariables {
  id: string;
  level: RealEstateLevel;
}

export interface IAgentByIdVariables {
  id: string;
}

export interface IOfficeListingsVariables {
  officeId?: string;
  listingsType: MarketplaceType;
  limit: number;
  _cachePreventor?: number;
}

export interface ITeamByOfficeIdVariables {
  id: string;
  shuffle: boolean;
}

export interface IMortgageOfficeByIdVariables {
  query: { ids: string[]; };
}

export interface IDevelopersAndPromotedProjectsVariables {
  ids: string[];
}

export interface ISearchAwardsByIdsVariables {
  ids: string[];
  products?: AwardCategories[];
  features?: LeadingAgentFeature[];
  year?: number;
}

export interface ISearchAwardsByDocIdsVariables {
  docIds: string[];
  products?: AwardCategories[];
  features?: LeadingAgentFeature[];
  year?: number;
  includeOnlyRelevantFeatures: boolean;
}

export interface ISearchDevelopersVariables {
  query: {
    cityDocId?: string;
    neighborhoodDocId?: string;
    publishStatus?: Array<'PUBLISHED' | 'DRAFT'>;
    offset?: number;
    limit?: number;
  };
}

export interface IMortgageOfficesByCityDocIdsVariables {
  query: {
    cityDocIds: string[];
    offset?: number;
    limit?: number;
  };
}

export enum SearchDealsSortColumn {
  Price = 'AMOUNT',
  PricePerSqM = 'PRICE_PER_METER',
  Rooms = 'NUM_ROOMS',
  Floor = 'FLOOR',
  Area = 'GROSS_AREA',
  DealDate = 'DEAL_DATE',
  BuildingYear = 'BUILDING_YEAR',
}

export interface ISearchDealVariables {
  userToken?: string;
  filters?: {
    docId?: string;
    price?: ISearchNumberRange;
    rooms?: ISearchNumberRange;
    date?: ISearchDateRange;
    parcelBlock?: {
      parcel: number;
      block: number;
    };
  };
  sort: {
    sortColumn: SearchDealsSortColumn | string;
    sortOrder: 'ASC' | 'DESC';
  };
  offset?: number;
  limit?: number;
}

export interface IGetDealAffiliationRequestsBySaleIdVariables {
  userToken?: string;
  saleId: string;
}

export interface IGetCommercialListingVariables {
  id: string;
}

export interface IGetResidentialListingVariables {
  id: string;
  userToken?: string;
}

interface ListingSortOptions {
  sortColumn: string;
  sortOrder: string;
}

export interface IGetResidentialAndCommercialListingsVariables {
  userToken?: string;
  sortOptions?: ListingSortOptions;
  offset?: number;
  limit?: number;
  filters?: {
    agents?: string[];
    textFilterValue?: string;
    textFilterType?: string;
  };
}

export interface IBusRouteByIdsVariables {
  busLineIds: string[];
}

export interface IGetBulletinsUsageOverviewVariables {
  userToken?: string;
  agents?: string[];
}

export enum SchoolLocation {
  Address = 'ADDRESS',
  City = 'CITY',
  Neighbourhood = 'NEIGHBOURHOOD',
}

export enum InformationSource {
  AddressSearch = 'ADDRESS_SEARCH',
  InfoPage = 'INFO_PAGE',
}

export interface ISortedBulletinsWithPlans {
  sortedBulletinsWithPlans: Array<{
    bulletin: IBulletin | ICommercialBulletin;
    promotionPlan: UserPromotionPlan | UserBulletinPromotionPlan;
  }>;
  activeBulletins: Array<IBulletin | ICommercialBulletin>;
  frozenBulletins: Array<IBulletin | ICommercialBulletin>;
}

export interface ISchoolByLocationVariables {
  input: {
    docId: string;
    locationType: SchoolLocation;
    source: InformationSource;
  };
}

export type IMixedApiInsightsVariables = IDocId2InsightsVariables & ISchoolByLocationVariables;

export interface IListingSearchDataVariables {
  id: string;
  type: MarketplaceType;
}
export interface NeighborhoodQueryVariables extends ISearchDevelopersVariables {
  neighborhoodDocId: string;
  // different queries insight use a different type for UserToken thus a workaround is necessary
  userToken1: string;
  userToken2: string;
}


export interface VariablesByType {
  [LoadType.GetProfessionalUserInfo]: {};
  [LoadType.ComparedNeighbourhoodInvestorPriceTrendsInsight]: IDocId2InsightsVariables;
  [LoadType.ComparedNeighbourhoodInvestorSummary]: NeighborhoodQueryVariables;
  [LoadType.NeighbourhoodInvestorPriceTrendsInsight]: IDocId2InsightsVariables;
  [LoadType.NeighbourhoodInvestorSummary]: NeighborhoodQueryVariables;
  [LoadType.InvestorSimilarNeighbourhoods]: {
    neighborhoodDocId: string;
    userToken: string;
  };
  [LoadType.GetPublicRealEstateAgentById]: {
    agentId: string;
  };
  [LoadType.GetPublicRealEstateAgentsByIds]: {
    agentsIds: string[];
  };
  [LoadType.GetPublicRealEstateOfficesByIds]: {
    officesIds: string[];
  };
  [LoadType.GetPublicRealEstateOfficeById]: {
    officeId: string;
  };
  [LoadType.SchoolByLocation]: ISchoolByLocationVariables;
  [LoadType.AddressSearch]: ISearchPoiVariables;
  [LoadType.SchoolSearch]: ISearchPoiVariables;
  [LoadType.StreetSearch]: ISearchPoiVariables;
  [LoadType.SearchProjectList]: ISearchPoiVariables;
  [LoadType.Insights]: IDocId2InsightsVariables;
  [LoadType.MixedApiInsights]: IMixedApiInsightsVariables;
  [LoadType.NeighborhoodPublicInsights]: INeighborhoodPublicInsightsVariables;
  [LoadType.SearchList]: ISearchPoiVariables;
  [LoadType.ProjectsSearchResultList]: ISearchPoiVariables;
  [LoadType.SearchMapListings]: ISearchPoiVariables;
  [LoadType.SearchMapDataLayers]: IDataLayersVariables;
  [LoadType.SearchMapDataLayersV3]: IDataLayersVariables;
  [LoadType.SearchMapClusters]: IDataLayersVariables;
  [LoadType.CurrentUser]: {
    userToken?: string,
  };
  [LoadType.CurrentUserSearchHistory]: {
    userToken?: string,
  };
  [LoadType.SavedSearchesNotifications]: {
    userToken?: string,
  };
  [LoadType.SearchHistoryNotifications]: {
    userToken?: string,
  };
  [LoadType.FavoriteNeighborhoods]: {
    userToken: string;
  };
  [LoadType.VerifyResetPasswordRequest]: IVerifyResetPasswordRequestVariables;
  [LoadType.SearchDoc]: IDocIds2InformationVariables;
  [LoadType.AddressDoc]: IDocId2InformationVariables;
  [LoadType.LocalDoc]: ILocalPageVariables;
  [LoadType.AddressesByDocIds]: { docIds: string[] };
  [LoadType.LocalDocPreview]: ILocalPageVariables;
  [LoadType.SearchLocalAddressPage]: ILocalPageVariables;
  [LoadType.StrictLocalDoc]: IDocId2InformationVariables;
  [LoadType.CommercialLocalInfo]: ICommercialLocalInfoVariables;
  [LoadType.AreasWithCommercialInfoPage]: {};
  [LoadType.StrictUnitDoc]: IDocId2InformationVariables;
  [LoadType.UnitPageBulletin]: IPoiByIdsVariables;
  [LoadType.UnitPageCommercialBulletin]: IPoiByIdsVariables;
  [LoadType.ProjectPageProject]: IPoiByIdsVariables;
  [LoadType.ProjectPageCommercialProject]: IPoiByIdsVariables;
  [LoadType.MapPreview]: IPoiByIdsVariables;
  [LoadType.MapMultiPreview]: IPoiByIdsVariables;
  [LoadType.ShortlistPois]: IPoiByIdsVariables;
  [LoadType.FavoritesPois]: IPoiByIdsVariables;
  [LoadType.EditListingPoi]: IEditListingPoiByIdsVariables;
  [LoadType.IlHomePageBulletins]: ILHomePageSearchTemporaryInterface;
  [LoadType.SearchBySearchId]: { searchId: string };
  [LoadType.UserListings]: IUserListingsVariables;
  [LoadType.SearchByUserIdAndSearchId]: { token: string; isProjectEmail?: boolean };
  [LoadType.UserAllListings]: Omit<IUserListingsVariables, 'limit' | 'offset'>;
  [LoadType.LocalData]: ILocalDataVariables;
  [LoadType.Deal]: IPoiByIdsVariables;
  [LoadType.UserContent]: IUserContentVariables;
  [LoadType.UserContentTextReviews]: IUserContentTextReviewsVariables;
  [LoadType.UserContentRatingReviews]: IUserContentRatingReviewsVariables;
  [LoadType.Madad]: IMadadVariables;
  [LoadType.HomePageBanner]: IHPBannerVariables;
  [LoadType.BannersByDocId]: IBannersByDocIdVariables;
  [LoadType.SearchPageBannersByDocId]: IBannersByDocIdVariables;
  [LoadType.AdditionalBannersByDocId]: IBannersByDocIdVariables;
  [LoadType.MadadWinnersBannersByDocId]: IMadadWinnersBannersByDocIdVariables;
  [LoadType.MadadWinnersBannersForStreetByDocId]: IMadadWinnersBannersForStreetByDocIdVariables;
  [LoadType.MadadWinnersExistForDocId]: IMadadWinnersBannersByDocIdVariables;
  [LoadType.MadadWinnersExistForStreetForDocId]: IMadadWinnersBannersForStreetByDocIdVariables;
  [LoadType.Tabu]: ITabuByDocIdVariables;
  [LoadType.FooterByDocId]: IFooterByDocIdVariables;
  [LoadType.MadadParticipants]: IMadadParticipantsVariables;
  [LoadType.MadadAgentsOffices]: IMadadAgentsOfficesVariables;
  [LoadType.MadadSearchAgentsOffices]: IMadadAgentsOfficesVariables;
  [LoadType.AgentsOfOfficeById]: IAgentsOfOfficeByIdVariables;
  [LoadType.AdminSearch]: IAdminSearchVariables;
  [LoadType.MadadAgentBanner]: {
    docId: string;
    agentId?: string;
  };
  [LoadType.ProjectMapLogo]: IProjectMapLogoVariables;
  [LoadType.IsPhoneRegistered]: IPhoneRegisteredVariables;
  [LoadType.DeveloperById]: IDeveloperByIdVariables;
  [LoadType.SearchDevelopers]: ISearchDevelopersVariables;
  [LoadType.MortgageOfficesByCityDocIds]: IMortgageOfficesByCityDocIdsVariables;
  [LoadType.BusRouteByIds]: IBusRouteByIdsVariables;
  [LoadType.OfficeById]: IOfficeByIdVariables;
  [LoadType.OfficeDataById]: IOfficeByIdVariables;
  [LoadType.OfficeBulletinsById]: IOfficeByIdVariables;
  [LoadType.AgentById]: IAgentByIdVariables;
  [LoadType.AgentContactInfoById]: IAgentByIdVariables;
  [LoadType.GetOfficeListings]: IOfficeListingsVariables;
  [LoadType.AgentBulletinsById]: IAgentByIdVariables;
  [LoadType.AgentWithBulletinsById]: IAgentByIdVariables;
  [LoadType.TeamByOfficeId]: ITeamByOfficeIdVariables;
  [LoadType.AdditionalCarouselSearch]: ISearchPoiVariables;
  [LoadType.ListingPostLeadCarouselSearch]: ISearchPoiVariables;
  [LoadType.MortgageOfficeById]: IMortgageOfficeByIdVariables;
  [LoadType.DevelopersAndPromotedProjects]: IDevelopersAndPromotedProjectsVariables;
  [LoadType.SearchAwardsByIds]: {
    args: ISearchAwardsByIdsVariables;
  };
  [LoadType.GetUnitPageLeadingData]: {
    args: ISearchAwardsByIdsVariables;
  };
  [LoadType.SearchAwardsByDocIds]: {
    args: ISearchAwardsByDocIdsVariables;
  };
  [LoadType.UserNotificationDevices]: {
    // not a real variable, used to avoid caching of the query
    __uid: string;
  };
  [LoadType.GetDealsAffiliationRequests]: { userToken?: string; };
  [LoadType.SearchDeals]: ISearchDealVariables;
  [LoadType.GetDealAffiliationRequestsBySaleId]: IGetDealAffiliationRequestsBySaleIdVariables;
  [LoadType.GetCommercialListing] : IGetCommercialListingVariables;
  [LoadType.GetResidentialListing] : IGetResidentialListingVariables;
  [LoadType.FeaturedMortgageOffice]: {};
  [LoadType.GetResidentialAndCommercialListings]: IGetResidentialAndCommercialListingsVariables;
  [LoadType.GetBulletinsUsageOverview]: IGetBulletinsUsageOverviewVariables;
  [LoadType.CurrentPromotionPlan]: { uiNonCache?: string; userToken?: string };
  [LoadType.ActivePromotionPlans]: { group?: string; userToken?: string; bulletinId?: string; uiNonCache?: string; isNewGeneration: boolean };
  [LoadType.UserCurrentPromotionPlan]: { userToken?: string; uiNonCache?: string; };
  [LoadType.GetAgentOrOfficeSummary]: { userToken?: string };
  [LoadType.SchoolByIdQuery]: { id: string };
  [LoadType.InvestorMarketStats]: {};
  [LoadType.InvestorNationalSalesHistory]: {};
  [LoadType.InvestorPopularListingsOnePerCity]: {};
  [LoadType.InvestorSuggestedListings]: { userToken: string };
  [LoadType.InvestorBulletinsWithPriceDrop]: { userToken: string };
  [LoadType.InvestorHighRentYieldNeighborhoods]: { userToken: string };
  [LoadType.InvestorHighRentYieldUserPreferencesNeighborhoods]: { userToken: string; usePreferences: boolean };
  [LoadType.InvestorCalculatedInvestorBudget]: { userToken: string };
  [LoadType.InvestorNeighborhoodsWithGrowthPotential]: { userToken: string };
  [LoadType.InvestorUserPreferencesNeighborhoodsWithGrowthPotential]: { userToken: string; usePreferences: boolean };
  [LoadType.InvestorPreferences]: { userToken: string };
  [LoadType.InvestorSuggestedNeighborhoods]: { userToken: string };
  [LoadType.ListingSearchData]: IListingSearchDataVariables;
  [LoadType.InvestorRecentSearches]: { userToken: string };
  [LoadType.InvestorMatchedListingsCount]: {
    userToken: string;
    input: {
      budget?: number;
      neighborhoodDocIds: string[];
    };
  };
  [LoadType.HomepageLastSearchListings]: ISearchPoiVariables;
  [LoadType.UserPaymentTransaction]: IUserPaymentTransactionVariables;
  [LoadType.UserPaymentTransactions]: IUserPaymentTransactionsVariables;
}

export type MapPreviewProjectFields = 'id' | keyof IProject;
export type MapPreviewCommercialProjectFields = 'id' | keyof ICommercialProject;

export type MapPreviewBulletinFields =
  'id'
  | 'type'
  | 'addressDetails'
  | 'price'
  | 'dealType'
  | 'images'
  | 'firstTimeSeen'
  | 'lastUpdated'
  | 'buildingClass'
  | 'area'
  | 'beds'
  | 'poc'
  | 'insights';

export type MapPreviewCommercialBulletinFields =
  'id'
  | 'type'
  | 'addressDetails'
  | 'price'
  | 'dealType'
  | 'images'
  | 'firstTimeSeen'
  | 'lastUpdated'
  | 'buildingClass'
  | 'area'
  | 'rooms'
  | 'poc'
  | 'insights';

export type SearchMapBulletinFields =
  'locationPoint'
  | 'price'
  | 'id'
  | 'addressDetails'
  | 'type'
  | 'firstTimeSeen'
  | 'poc';
export type SearchMapProjectFields =
  'locationPoint'
  | 'id'
  | 'addressDetails'
  | 'type'
  | 'promotionStatus'
  | 'firstTimeSeen';


export interface ICurrentUserResponse {
  me: User;
}

export type IlHomePageBulletinsResponse = {
  [key: string]: {
    poi: Array<IBulletin | IProject>;
  },
} & {
  totalBulletinsSection1: { total: number },
  totalBulletinsSection2: { total: number },
  totalBulletinsSection3: { total: number },
};

export interface ISearchBySearchIdResponse {
  searchBySearchId: ISaveSearch;
}

export interface IUserListingsResponse {
  getUsersListings: {
    residential: IBulletin[];
    commercial: ICommercialBulletin[];
  };
}

export interface ISearchByUserIdAndSearchIdResponse {
  getSearchByUserIdAndSearchId: ISearch;
}

export interface AgentsOfOfficeByIdResponse {
  getAllAgentsInOffice: AgentOfOfficeById[];
}

export interface ILocalDataResponse {
  ppa?: number;
  yearNumberOfDeals?: number;
  document: IAutocompleteEntry;
}

export interface MadadAgentCityBannerItem {
  imageUrl: string;
  officeName: string;
  agentName: string;
  agentId: string;
  url: string;
  city?: string;
  category?: 'top_10_gold' | 'top_10';
  officeLogoUrl?: string;
}

export interface MadadAgentLandingBannerItem extends MadadAgentCityBannerItem {
  city: string;
}

export type MadadAgentBannerItem = MadadAgentLandingBannerItem | MadadAgentCityBannerItem;

export interface MadadAgentBannerResponse {
  getMadadAgentBanner: MadadAgentBannerItem;
}


export interface AdminSearResponse {
  userListingsWithOffices: {
    listings: IUserListingsResponse['getUsersListings'];
    agentsInOffice: AgentsOfOfficeByIdResponse['getAllAgentsInOffice'];
  };
}

export interface AgentOfOfficeById {
  agentId: string;
  userId: string;
  name: string;
  officeId: string;
}

export type ISearchNotificationJar = Pick<ISaveSearch, 'searchId' | 'searchPreviews' | 'notificationsCount'>;

export interface IDataLayersResponse<T extends IDataLayer> {
  searchDataLayers?: {
    poi: T[];
  };

  [z: number]: Record<PoiId, T>;
}


interface BusStationLayerV3 {
  id: string;
  geometry: {
    type: 'POINT';
    coordinates: number[];
  };
  type: 'busStation';
  busStopName: string;
  busLines: Array<{
    id: string;
    name: string;
  }>;
}

interface TrainStationLayerV3 {
  id: string;
  geometry: {
    type: 'POINT';
    coordinates: number[];
  };
  type: 'trainStation';
  name: string;
  address: string;
}

type DataLayersV3 = BusStationLayerV3 | TrainStationLayerV3;

export interface IDataLayersV3Response {
  searchDataLayers?: DataLayersV3[];
}

export interface UserNotificationDevice {
  deviceId: string;
  deviceType: DeviceType;
}

export interface IUserNotificationDeviceResponse {
  getNotificationDevices: UserNotificationDevice[];
}

export interface ISearchAwardsByIdsResponse {
  searchAwardsByIds: Award[];
}
export interface ISearchAwardsByDocIdsResponse {
  searchAwardsByDocIds: Award[];
}

export interface GetBulletinsUsageOverviewResponse {
  totalPresentedBulletins: number;
  totalBulletinsCredit: number;
  totalPromotedBulletins: number;
  totalPromotedCredit: number;
  totalFrozenBulletins: number;
  totalOfficePresentedBulletins: number;
  totalOfficeFrozenBulletins: number;
  totalOfficePromotedBulletins: number;
  totalOfficeUsedBulletinsCredit: number;
  totalResidentialRentCredit: number;
  totalOfficeDisplayedResidentialRent: number;
  totalPresentedResidentialRentBulletins: number;
}

export interface IGetPublicRealEstateAgentsByIdsResponseItem {
  agentId: string;
  name: string;
  iconUrl: string;
}

export interface IGetPublicRealEstateOfficesByIdsResponseItem {
  officeId: string;
  officeName: string;
  hideDealsOnPublicSite: boolean;
  iconUrl: string;
}

export enum PromotionPlanType {
  ADVANCE = 'ADVANCE',
  BASIC = 'BASIC',
  PREMIUM = 'PREMIUM',
  MINI = 'MINI',
}

export enum PromotionPlanVariant {
  BASIC = 'BASIC',
  MINI = 'MINI',
  ADVANCE = 'ADVANCE',
  PREMIUM = 'PREMIUM',
  UNTIL_SOLD = 'UNTIL_SOLD',
  SUBSCRIPTION_MONTHLY = 'SUBSCRIPTION_MONTHLY',
}

export enum PromotionPlanLevel {
  ACCOUNT = 'ACCOUNT',
  BULLETIN = 'BULLETIN',
}

export interface PromotionPlanInfo {
  id: string;
  type: PromotionPlanType;
  variant: PromotionPlanVariant;
  level: PromotionPlanLevel;
  active: boolean;
  durationDays: number;
  intervalMinutes: number;
  name: string;
  price: number;
  isUserEligibleForGrant?: boolean;
  offerValidUntil?: ISOString;
}

export interface BulletinPromotionLog {
  bulletinId: string;
  promotedAt: ISOString;
  promotedUntil: ISOString;
}

export interface UserPromotionPlanTimelineItem {
  id: string;
  planId: string;
  planType: PromotionPlanType;
  planVariant: PromotionPlanVariant;
  startDate: ISOString;
  endDate: ISOString;
}

export interface UserPromotionPlan {
  id: string;
  userId: string;
  startDate: ISOString;
  endDate: ISOString;
  isGrantPlan: boolean;
  promotionPlan: PromotionPlanInfo;
  latestManualPromotions: BulletinPromotionLog[];
  latestAutomaticPromotions: BulletinPromotionLog[];
  promotionPlansTimeline: UserPromotionPlanTimelineItem[];
}

export interface UserBulletinPromotionPlan {
  userPromotionPlanId: string;
  bulletinId: string;
  promotionPlan: PromotionPlanInfo;
  startDate: ISOString;
  endDate: ISOString;
  isGrantPlan: boolean;
  latestManualPromotion: BulletinPromotionLog;
  latestAutomaticPromotion: BulletinPromotionLog;
  nextChargeDate: ISOString;
  upcomingAutoPromotionDates: string[];
}

export interface UserCurrentPromotionPlanResponse {
  accountPromotionPlan: UserPromotionPlan;
  bulletinPromotionPlans: UserBulletinPromotionPlan[];
}

export interface IAgentOrOfficeSummary {
  numberOfActiveAgents: number;
  numberOfActiveBulletins: number;
  numberOfBulletinsCredit: number;
  numberOfPromotedBulletins: number;
  numberOfPromotedCredit: number;
  numberOfExclusiveBulletins: number;
  numberOfReports: number;
  numberOfApprovedDeals: number;
  reportsCredit: number;
  numberOfUsedBulletinsCredit: number;
  numberOfResidentialRentCredit: number;
  numberOfActiveResidentialRentBulletins: number;
}

export type SchoolUnion = IElementarySchool | IHighSchool;

export enum SchoolLevel {
  ELEMENTARY = 'ELEMENTARY',
  HIGHSCHOOL = 'HIGHSCHOOL',
}

export enum OldSchoolLevel {
  ELEMENTARY = 'Elementary',
  HIGHSCHOOL = 'HighSchool',
}

export interface IElementarySchool {
  schoolId: string;
  schoolName: string;
  classRange: string;
  schoolLevel: SchoolLevel.ELEMENTARY;
  cityDocId: string;
  neighborhoodDocId: string;
  docId: string;
  numberOfStudents: number;
  averageNumberOfStudentsPerClass: number;
  ramaProfessionalEvaluation: string;
  sector: string;
  address: string;
  settlement: string;
  supervision: string;
  yearEstablished: number;
  registrationZones: Array<{
    geometry: MultiPolygon;
  }>;
  geometry: {
    coordinates: [ number, number ];
  };
}

export interface IHighSchool {
  schoolId: string;
  schoolName: string;
  address: string;
  settlement: string;
  cityDocId: string;
  neighborhoodDocId: string;
  docId: string;
  yearEstablished: number;
  supervision: string;
  sector: string;
  civics2UnitsAverageGrade: number;
  literature2UnitsAverageGrade: number;
  history2UnitsAverageGrade: number;
  bible2UnitsAverageGrade: number;
  numberOfStudents: number;
  averageNumberOfStudentsPerClass: number;
  hebrew2UnitsAverageGrade: number;
  math5UnitsEligibilityPercent: number;
  math5UnitsAverageGrade: number;
  math4UnitsEligibilityPercent: number;
  math4UnitsAverageGrade: number;
  english5UnitsEligibilityPercent: number;
  english5UnitsAverageGrade: number;
  english4UnitsEligibilityPercent: number;
  english4UnitsAverageGrade: number;
  madlanEducationIndexInstitutional: number;
  madlanEducationIndexCityAverage: number;
  neighborhoodMadadMadlan: number;
  madlanEducationIndexNationalAverage: number;
  talentedPercentInstitutional: number;
  talentedPercentCityAverage: number;
  talentedPercentNationalAverage: number;
  numberOfGiftedPlans: number;
  numberOfGiftedPlansCityAverage: number;
  numberOfGiftedPlansNationalAverage: number;
  matriculationEligibilityInstitutional: number;
  matriculationEligibilityCityAverage: number;
  matriculationEligibilityNationalAverage: number;
  matriculationExcellenceInstitutional: number;
  matriculationExcellenceCityAverage: number;
  matriculationExcellenceNationalAverage: number;
  dropoutPercentInstitutional: number;
  dropoutPercentCityAverage: number;
  dropoutPercentNationalAverage: number;
  teachersWithMastersInstitutional: number;
  teachersWithMastersCityAverage: number;
  teachersWithMastersNationalAverage: number;
  techMatriculationInstitutional: number;
  techMatriculationCityAverage: number;
  techMatriculationNationalAverage: number;
  classRange: string;
  schoolLevel: SchoolLevel.HIGHSCHOOL;
  registrationZones: Array<{
    geometry: MultiPolygon;
  }>;
  geometry: {
    coordinates: [ number, number ];
  };
}

export interface IInvestorMarketLatestStats {
  totalDeals: number;
  totalDealsMonthDiff: number;
  investorPurchases: number;
  investorPurchasesMonthDiff: number;
  investorSales: number;
  investorSalesMonthDiff: number;
  year: number;
  month: number;
}
export interface IInvestorMarketStats {
  latest: IInvestorMarketLatestStats;
}

export interface IInvestorsHistory {
  year: number;
  newPropertySales: number;
  oldPropertySales: number;
}

export interface IInvestorNationalSalesHistory {
  history: IInvestorsHistory;
}

export interface IInvestorPopularListings {
  id: string;
  listing: IBulletin;
}

export interface IInvestorSuggestedListings {
  listing: IBulletin;
}

export enum NeighborhoodPricePerMeterLabel {
  AMONG_HEIGHEST_IN_CITY = 'AMONG_HEIGHEST_IN_CITY',
  AMONG_LOWEST_IN_CITY = 'AMONG_LOWEST_IN_CITY',
}

export enum NeighborhoodDealsVolumeLabel {
  TOP1 = 'TOP1',
  TOP3 = 'TOP3',
  LEAST = 'LEAST',
}

export enum NeighborhoodPopularRoomLabel {
  TWO = 'TWO',
  THREE = 'THREE',
  FOUR = 'FOUR',
  FIVE = 'FIVE',
}

export enum NeighborhoodPriceTrendComparedToCityLabel {
  STABLE = 'STABLE',
  INCREASING = 'INCREASING',
  DECREASING = 'DECREASING',
}

export interface NeighborhoodCardLabels {
  pricePerMeter?: NeighborhoodPricePerMeterLabel;
  dealsVolume?: NeighborhoodDealsVolumeLabel;
  popularRoom?: NeighborhoodPopularRoomLabel;
  priceTrendComparedToCity?: NeighborhoodPriceTrendComparedToCityLabel;
}

export interface InvestorNeighborhoodCard {
  neighborhoodDocId: string;
  labels?: NeighborhoodCardLabels;
  monthlyViews?: number;
}

export interface IHighRentYieldNeighborhood {
  neighborhoodDocId: string;
  neighborhoodName: string;
  cityName: string;
  averageYield: number;
  investorCard: InvestorNeighborhoodCard;
}

export interface INeighborhoodsWithGrowthPotential {
  neighborhoodDocId: string;
  neighborhoodName: string;
  cityName: string;
  investorCard: InvestorNeighborhoodCard;
}

export enum IInvestmentGoal {
  Appreciation  = 'APPRECIATION',
  RentalYield = 'RENTAL_YIELD',
  Balance = 'BALANCE',
}

interface AutocompleteDocumentRef {
  __typename?: 'AutocompleteDocumentRef';
  docId: string;
  ref?: AutocompleteDocumentUnion;
}

export interface IInvestorPreferences {
  budget: number;
  places: AutocompleteDocumentRef[];
  hasProperty: boolean;
  goal: IInvestmentGoal;
}

export interface IInvestorSuggestedNeighborhoods {
  neighborhoodDoc: AutocompleteDocumentRef;
  matchedListingsCount: number;
  monthlyViews: number;
  investorCard: InvestorNeighborhoodCard;
}

export interface IInvestorRecentSearch {
  id: string;
  doc: {
    docId: string;
    ref?: IAutocompleteNeighbourhood;
  };
}

export type PaymentTransactionStatus = 'SUCCESS' | 'PENDING' | 'FAILED';

export interface IUserPaymentTransactionResponse {
  paymentId: string;
  status: PaymentTransactionStatus;
  transactionResponseCode?: string;
  transactionResponseCodeMessage?: string;
}

export interface INeighborhoodSummaryDocument {
  neighborhoodDoc: {
    docId: string;
    ref?: IAutocompleteNeighbourhood;
  };
  investorCard: InvestorNeighborhoodCard;
}

export interface INeighbourhoodInvestorSummary extends INeighborhoodSummaryDocument {
  similarNeighborhoods: INeighborhoodSummaryDocument[];
  averageRentYield?: number;
  priceTrendComparison?: {
    comparisonSentenceHebrew: string;
  };
  crime?: {
    rateComparedToCity?: INeighbourhoodCrimeRateLevel;
    history: ICrimeHistoryDataPoint[];
  };
  heatIndex: {
    rentVsOwnershipRatio?: {
      renters: number;
      propertyOwners: number;
    };
    neighborhoodCityPricesRatio?: {
      neighborhood: number;
      city: number;
    };
    sellersBuyersRatio?: {
      sellers: number;
      buyers: number;
    }
  };
}

export interface IFavoriteNeighbourhood {
  doc: AutocompleteDocumentRef;
  matchedListingsCount: number;
  investorCard: InvestorNeighborhoodCard;
}

export interface INeighbourhoodPropertiesStock {
  unitsWithPendingBuildingPermit: IUnitsByYear[];
  unitsWithBuildingPermit: IUnitsByYear[];
  propertiesStock: IUnitsByYear[];
}

export interface INeighbourhoodDealsSummary {
  totalDeals: number;
  totalDealsTrend: number;
  averagePricePerMeter: number;
  averagePricePerMeterTrend: number;
}

export interface IAverageBuildingYearByNeighbourhoodDocId {
  averageBuildingYear: number;
}

export interface IPriceChangeOverPastNYears {
  pastNYearsPriceChangePercent: number;
  averageAnnualPriceChangePercent: number;
}

export interface IPermitsTrendByNeighborhood {
  trend: 'INCREASE' | 'DECREASE' | 'STABLE';
  lastYearPermits: number;
  pastPermits: number;
}

export interface INeighbourhoodProjectsBuildingRequests {
  approvedBuildingRequests: IBuildingRequest[];
  pendingBuildingRequests: IBuildingRequest[];
}

export interface INeighbourhoodInvestorSummaryResponse extends SearchDevelopersResponse, ILocalPageResponse {
  neighborhoodInvestorSummary: INeighbourhoodInvestorSummary;
  neighborhoodPropertiesStock: INeighbourhoodPropertiesStock;
  getNeighbourhoodDealsSummary: INeighbourhoodDealsSummary;
  getAverageBuildingYearByNeighbourhoodDocId: IAverageBuildingYearByNeighbourhoodDocId;
  priceChangeOverPastNYears: IPriceChangeOverPastNYears;
  permitsTrendByNeighborhood: IPermitsTrendByNeighborhood;
  neighborhoodProjectsBuildingRequests: INeighbourhoodProjectsBuildingRequests;
  getDealsCountTrend: IDealsNumTrendsListItem[];
  priceTrendsList: IPriceTrendsListItem[];
}

export interface ISimilarNeighbourhoodInvestorsResponse {
  neighborhoodInvestorSummary: {
    similarNeighborhoods: INeighborhoodSummaryDocument[];
  };
}

export interface IProfessionalUserInfo {
  isPermitted: boolean;
  role: ProfessionalUserRole;
}

export interface ResponseByType {
  [LoadType.GetProfessionalUserInfo]: {
    getProfessionalUserInfo: IProfessionalUserInfo;
  };
  [LoadType.ComparedNeighbourhoodInvestorPriceTrendsInsight]: IDocId2InsightsResponse;
  [LoadType.ComparedNeighbourhoodInvestorSummary]: INeighbourhoodInvestorSummaryResponse;
  [LoadType.NeighbourhoodInvestorPriceTrendsInsight]: IDocId2InsightsResponse;
  [LoadType.NeighbourhoodInvestorSummary]: INeighbourhoodInvestorSummaryResponse;
  [LoadType.InvestorSimilarNeighbourhoods]: ISimilarNeighbourhoodInvestorsResponse;
  [LoadType.FavoriteNeighborhoods]: {
    favoriteNeighborhoods: IFavoriteNeighbourhood[];
  };
  [LoadType.GetPublicRealEstateAgentsByIds]: {
    getPublicRealEstateAgentsByIds: IGetPublicRealEstateAgentsByIdsResponseItem[];
  };
  [LoadType.GetPublicRealEstateOfficesByIds]: {
    getPublicRealEstateOfficesByIds: IGetPublicRealEstateOfficesByIdsResponseItem[];
  };
  [LoadType.GetPublicRealEstateOfficeById]: {
    getPublicRealEstateOfficeById: IOfficePageData;
  };
  [LoadType.GetPublicRealEstateAgentById]: {
    getPublicRealEstateAgentById: IPublicRealEstateAgent;
  };
  [LoadType.AddressSearch]: {
    searchPoiV2: {
      poi: Array<IBulletin | IProject>;
      cursor?: unknown;
      total?: number;
    };
  };
  [LoadType.SchoolSearch]: {
    searchPoiV2: {
      poi: Array<IBulletin | IProject>;
      cursor?: unknown;
      total?: number;
    };
  };
  [LoadType.StreetSearch]: {
    poiByDocId: {
      poi: Array<IBulletin | IProject>;
      cursor?: unknown;
      total?: number;
    };
  };
  [LoadType.SearchProjectList]: {
    searchPoiV2: {
      poi: Array<IBulletin | IProject>;
    },
  };
  [LoadType.Insights]: IDocId2InsightsResponse;
  [LoadType.MixedApiInsights]: IDocId2InsightsResponse;
  [LoadType.NeighborhoodPublicInsights]: INeighborhoodPublicInsightsResponse;
  [LoadType.SearchList]: {
    searchPoiV2: {
      poi: Array<IBulletin | IProject | ICommercialProject | ICommercialBulletin | IAd>;
      cursor?: Cursor;
      total?: number;
      totalNearby?: number;
      lastInGeometryId?: string;
    };
  };
  [LoadType.ProjectsSearchResultList]: {
    searchPoiV2: {
      poi: Array<IBulletin | IProject | ICommercialProject | ICommercialBulletin | IAd>;
      cursor?: Cursor;
      total?: number;
      totalNearby?: number;
      lastInGeometryId?: string;
    };
  };
  [LoadType.AddressesByDocIds]: {
    addressesByDocIds: IBaseAutocompleteDoc[];
  };
  [LoadType.SearchMapClusters]: IDataLayersResponse<IClusterDataLayer>;
  [LoadType.SearchMapDataLayers]: IDataLayersResponse<IDataLayerItem>;
  [LoadType.SearchMapDataLayersV3]: IDataLayersV3Response;
  [LoadType.SearchMapListings]: {
    searchPoiV2: {
      poi: Array<Pick<IBulletin, SearchMapBulletinFields> | Pick<IProject, SearchMapProjectFields> | Pick<ICommercialBulletin, SearchMapBulletinFields> | Pick<ICommercialProject, SearchMapProjectFields>>,
    };
  };
  [LoadType.SearchHistoryNotifications]: {
    me: {
      searchHistory: ISearchNotificationJar[];
    },
  };
  [LoadType.SavedSearchesNotifications]: {
    me: {
      savedSearches: ISearchNotificationJar[];
    },
  };
  [LoadType.CurrentUser]: ICurrentUserResponse;
  [LoadType.CurrentUserSearchHistory]: ICurrentUserResponse;
  [LoadType.VerifyResetPasswordRequest]: IVerifyResetPasswordRequestResponse;
  [LoadType.SearchDoc]: IDocIds2InformationResponse;
  [LoadType.AddressDoc]: IDocId2InformationResponse;
  [LoadType.UnitPageBulletin]: IPoiByIdsResponse<IBulletin>;
  [LoadType.UnitPageCommercialBulletin]: IPoiByIdsResponse<ICommercialBulletin>;
  [LoadType.ProjectPageProject]: IPoiByIdsResponse<IProject>;
  [LoadType.ProjectPageCommercialProject]: IPoiByIdsResponse<ICommercialProject>;
  [LoadType.Deal]: {
    poiByIds: IDeal[];
  };
  [LoadType.MapPreview]: IPoiByIdsResponse<IBulletin | IProject | ICommercialProject | ICommercialBulletin>;
  [LoadType.MapMultiPreview]: IPoiByIdsResponse<IBulletin | IProject | ICommercialProject | ICommercialBulletin>;
  [LoadType.ShortlistPois]: IPoiByIdsResponse<IBulletin | IProject | ICommercialProject | ICommercialBulletin>;
  [LoadType.FavoritesPois]: IPoiByIdsResponse<IBulletin | IProject | ICommercialProject | ICommercialBulletin>;
  [LoadType.EditListingPoi]: IPoiByIdsResponse<IBulletin | IProject | ICommercialProject | ICommercialBulletin>;
  [LoadType.LocalDoc]: ILocalPageResponse;
  [LoadType.LocalDocPreview]: ILocalPagePreviewResponse;
  [LoadType.SearchLocalAddressPage]: ISearchLocalAddressPageResponse;
  [LoadType.StrictLocalDoc]: IDocId2InformationResponse;
  [LoadType.CommercialLocalInfo]: ICommercialLocalInfoResponse;
  [LoadType.AreasWithCommercialInfoPage]: {
    getAreasWithCommercialInfoPage: Area[],
  };
  [LoadType.StrictUnitDoc]: IDocId2InfoUnitResponse;
  [LoadType.IlHomePageBulletins]: IlHomePageBulletinsResponse;
  [LoadType.SearchBySearchId]: ISearchBySearchIdResponse;
  [LoadType.UserListings]: IUserListingsResponse;
  [LoadType.SearchByUserIdAndSearchId]: ISearchByUserIdAndSearchIdResponse;
  [LoadType.UserAllListings]: IUserListingsResponse;
  [LoadType.LocalData]: {
    docId2Information: ILocalDataResponse;
  };
  [LoadType.UserContent]: {
    userContent: InputUGCEntry[];
  };
  [LoadType.UserContentTextReviews]: {
    docId2TextReviews: IUserTextReviewResponse[];
  };
  [LoadType.UserContentRatingReviews]: {
    docId2NumericReviews: IUserRatingReviewResponse;
  };
  [LoadType.Madad]: MadadResponse;
  [LoadType.BannersByDocId]: {
    bannersByDocId: BannersByDocIdResponse[];
  };
  [LoadType.SearchPageBannersByDocId]: {
    bannersByDocId: BannersByDocIdResponse[];
  };
  [LoadType.AdditionalBannersByDocId]: {
    bannersByDocId: BannersByDocIdResponse[];
  };
  [LoadType.MadadWinnersBannersByDocId]: {
    madadWinnersBanners: MadadWinnersBannersByDocIdResponse[];
  };
  [LoadType.MadadWinnersBannersForStreetByDocId]: {
    madadWinnersBanners: MadadWinnersBannersByDocIdResponse[];
  };
  [LoadType.MadadWinnersExistForDocId]: {
    madadWinnersExist: boolean;
  };
  [LoadType.MadadWinnersExistForStreetForDocId]: {
    madadWinnersExist: boolean;
  };
  [LoadType.Tabu]: TabuByDocIdResponse;
  [LoadType.HomePageBanner]: HPBannerResponse;
  [LoadType.FooterByDocId]: {
    footerByDocId: FooterByDocIdResponse;
  };
  [LoadType.MadadParticipants]: {
    madadParticipants: MadadParticipantsResponse;
  };
  [LoadType.MadadAgentsOffices]: {
    madadAgentsOffices: MadadAgentsOfficesResponse;
  };
  [LoadType.MadadSearchAgentsOffices]: {
    madadAgentsOffices: MadadAgentsOfficesResponse;
  };
  [LoadType.MadadAgentBanner]: MadadAgentBannerResponse;
  [LoadType.AgentsOfOfficeById]: AgentsOfOfficeByIdResponse;
  [LoadType.AdminSearch]: AdminSearResponse;
  [LoadType.ProjectMapLogo]: ProjectMapLogoResponse;
  [LoadType.IsPhoneRegistered]: {
    isPhoneRegistered: boolean;
  };
  [LoadType.DeveloperById]: DeveloperByIdResponse;
  [LoadType.SearchDevelopers]: SearchDevelopersResponse;
  [LoadType.MortgageOfficesByCityDocIds]: MortgagOfficesByCityDocIdsResponse;
  [LoadType.BusRouteByIds]: BusRouteByIdsResponse;
  [LoadType.OfficeById]: OfficeByIdResponse;
  [LoadType.OfficeDataById]: OfficeDataByIdResponse;
  [LoadType.OfficeBulletinsById]: OfficeBulletinsByIdResponse;
  [LoadType.AgentById]: AgentByIdResponse;
  [LoadType.AgentWithBulletinsById]: AgentWithBulletinsByIdResponse;
  [LoadType.AgentContactInfoById]: AgentByIdResponse;
  [LoadType.AgentBulletinsById]: AgentBulletinsByIdResponse;
  [LoadType.TeamByOfficeId]: TeamByOfficeIdResponse;
  [LoadType.AdditionalCarouselSearch]: {
    searchPoiV2: {
      poi: Array<IBulletin | IProject | ICommercialProject | ICommercialBulletin>;
    },
  };
  [LoadType.ListingPostLeadCarouselSearch]: {
    searchPoiV2: {
      poi: Array<IBulletin | IProject | ICommercialProject | ICommercialBulletin>;
    },
  };
  [LoadType.MortgageOfficeById]: MortgageOfficeByIdResponse;
  [LoadType.GetOfficeListings]: OfficeListingsResponse;
  [LoadType.DevelopersAndPromotedProjects]: IDevelopersWithPromotedProjectsResponse;
  [LoadType.UserNotificationDevices]: IUserNotificationDeviceResponse;
  [LoadType.SearchAwardsByIds]: ISearchAwardsByIdsResponse;
  [LoadType.GetUnitPageLeadingData]: ISearchAwardsByIdsResponse;
  [LoadType.SearchAwardsByDocIds]: ISearchAwardsByDocIdsResponse;
  [LoadType.FeaturedMortgageOffice]: {
    getRandomFeaturedMortgageAdvisorsOffice: IMortgageOffice | null;
  };
  [LoadType.GetDealsAffiliationRequests]: GetDealsAffiliationRequestsResponse;
  [LoadType.SearchDeals]: SearchDealsResponse;
  [LoadType.GetDealAffiliationRequestsBySaleId]: GetDealAffiliationRequestsBySaleIdResponse;
  [LoadType.GetCommercialListing] : GetCommercialListingResponse;
  [LoadType.GetResidentialListing]: GetResidentialListingResponse;
  [LoadType.GetResidentialAndCommercialListings]: GetResidentialAndCommercialListingsResponse;
  [LoadType.GetBulletinsUsageOverview]: {
    getBulletinsUsageOverview: GetBulletinsUsageOverviewResponse;
  };
  [LoadType.CurrentPromotionPlan]: {
    currentPromotionPlan: UserPromotionPlan | null;
  };
  [LoadType.UserCurrentPromotionPlan]: {
    userCurrentPromotionPlan: UserCurrentPromotionPlanResponse | null;
  };
  [LoadType.ActivePromotionPlans]: {
    activePromotionPlans: PromotionPlanInfo[];
  };
  [LoadType.GetAgentOrOfficeSummary]: {
    getAgentOrOfficeSummary: IAgentOrOfficeSummary;
  };
  [LoadType.SchoolByIdQuery]: {
    getSchoolById: SchoolUnion;
  };
  [LoadType.SchoolByLocation]: {
    getSchoolsByLocation: SchoolUnion[];
  };
  [LoadType.InvestorMarketStats]: {
    investorMarketStats: {
      latest: IInvestorMarketStats;
    };
  };
  [LoadType.InvestorNationalSalesHistory]: {
    investorNationalSalesHistory: IInvestorNationalSalesHistory;
  };
  [LoadType.InvestorPopularListingsOnePerCity]: {
    popularListingsOnePerCity: IInvestorPopularListings[];
  };
  [LoadType.InvestorSuggestedListings]: {
    investorSuggestedListings: IInvestorSuggestedListings[];
  };
  [LoadType.InvestorBulletinsWithPriceDrop]: {
    investorBulletinsWithPriceDrop: IBulletin[];
  };
  [LoadType.InvestorHighRentYieldNeighborhoods]: {
    highRentYieldNeighborhoods: IHighRentYieldNeighborhood[];
  };
  [LoadType.InvestorNeighborhoodsWithGrowthPotential]: {
    neighborhoodsWithGrowthPotential: INeighborhoodsWithGrowthPotential[];
  };
  [LoadType.InvestorHighRentYieldUserPreferencesNeighborhoods]: {
    highRentYieldNeighborhoods: IHighRentYieldNeighborhood[];
  };
  [LoadType.InvestorUserPreferencesNeighborhoodsWithGrowthPotential]: {
    neighborhoodsWithGrowthPotential: INeighborhoodsWithGrowthPotential[];
  };
  [LoadType.InvestorCalculatedInvestorBudget]: {
    calculatedInvestorBudget: {
      loanAmount: number;
      monthlyPayment: number;
      totalBudget: number;
    };
  };
  [LoadType.InvestorPreferences]: {
    investorPreferences: IInvestorPreferences;
  };
  [LoadType.InvestorSuggestedNeighborhoods]: {
    investorSuggestedNeighborhoods: IInvestorSuggestedNeighborhoods[];
  };
  [LoadType.ListingSearchData]: ListingSearchDataResponse;
  [LoadType.InvestorRecentSearches]: {
    investorRecentSearches: IInvestorRecentSearch[];
  };
  [LoadType.InvestorMatchedListingsCount]: {
    investorMatchedListingsCount: Array<{
      neighborhoodDocId: string;
      matchedListingsCount: number;
    }>;
  };
  [LoadType.HomepageLastSearchListings]: {
    searchPoiV2: {
      poi: Array<IBulletin | IProject | ICommercialProject | ICommercialBulletin>;
    },
  };
  [LoadType.UserPaymentTransaction]: {
    userPaymentTransaction: IUserPaymentTransactionResponse,
  };
  [LoadType.UserPaymentTransactions]: {
    userPaymentTransactions: IUserPaymentTransactionResponse[],
  };
}


export interface LoadOptions<T extends LoadType> {
  loadType: T;
  meta: {
    initialize?: boolean;
    variables: VariablesByType[T];
    wasSSRHydrated?: boolean;
    /** handle with care */
    __fetchPolicy?: FetchPolicy;
    errorPolicy?: ErrorPolicy;
  };
}

export interface MutationOptionsMeta<T extends MutationType> {
  key?: string;
  variables: MutationVariablesByType[T];
  errorPolicy?: ErrorPolicy;
}

export interface MutationOptions<T extends MutationType> {
  mutationType: T;
  meta: MutationOptionsMeta<T>;
}

export enum MutationType {
  AddInvestorFavoriteNeighbourhood = 'addInvestorFavoriteNeighbourhood',
  RemoveInvestorFavoriteNeighbourhood = 'removeInvestorFavoriteNeighbourhood',
  FacebookLogin = 'facebookLogin',
  AppleLogin = 'appleLogin',
  CompleteAppleLogin = 'completeAppleLogin',
  GoogleLogin = 'googleLogin',
  LoginWithEmailAndPassword = 'loginWithEmailAndPassword',
  SignInSignUpWithEmail = 'SignInSignUpWithEmail',
  RegisterVisitor = 'registerVisitor',
  TempTokenAuth = 'TempTokenAuth',
  ResetPasswordUpdate = 'resetPasswordUpdate',
  UpdateUserProfile = 'updateUserProfile',
  ContactPageSubmit = 'contactPageSubmit',
  AgentOfficeContactPageSubmit = 'agentOfficeContactPageSubmit',
  ContactV4 = 'contactV4',
  SubmitLead = 'submitLead',
  ContactV4MortgageOffice = 'contactV4MortgageOffice',
  AddFavorites = 'addFavorites',
  RemoveFavorites = 'removeFavorites',
  AddContactAgent = 'addContactAgent',
  AddRecentlyViewed = 'addRecentlyViewed',
  SendFeedback = 'sendFeedback',
  SaveSearchQuery = 'saveSearchQuery',
  UpdateSearchQuery = 'updateSearchQuery',
  DeleteSaveSearch = 'deleteSearchQuery',
  SaveAddress = 'saveAddress',
  DeleteAddress = 'deleteAddress',
  SavedSearchUnsubscribe = 'savedSearchUnsubscribe',
  UnsubscribeFromSavedSearches = 'unsubscribeFromSavedSearches',
  UndoUnsubscribeFromSavedSearches = 'undoUnsubscribeFromSavedSearches',
  NewListing = 'newListing',
  NewListingValidation = 'newListingValidation',
  EditListing = 'editListing',
  EditListingValidation = 'editListingValidation',
  NewCommercialListing = 'newCommercialListing',
  EditCommercialListing = 'editCommercialListing',
  EditListingStatus = 'editListingStatus',
  EditCommercialListingStatus = 'editCommercialListingStatus',
  EditCommercialListingAssignedAgent = 'editCommercialListingAssignedAgent',
  EditCommercialListingPromotionStatus = 'editCommercialListingPromotionStatus',
  EditListingPromotionStatus = 'editListingPromotionStatus',
  UploadBulletinBadAddressReport = 'uploadBulletinBadAddressReport',
  EditBulletinStatus = 'editBulletinStatus',
  SaveRecentSearch = 'saveRecentSearch',
  AddUGC = 'addUGC',
  AddUGCEmotion = 'addUGCEmotion',
  FeedbackUGC = 'feedbackUGC',
  SaveUserData = 'saveUserData',
  LoginPersonalAssistant = 'loginPersonalAssistant',
  GenerateValidationCode = 'generateValidationCode',
  CheckValidationCode = 'checkValidationCode',
  SubmitContactMadlanLead = 'submitContactMadlanLead',
  SubmitDeveloperLead = 'submitDeveloperLead',
  DeregisterUser = 'deregisterUser',
  GetArticles = 'getArticles',
  AddNotificationDevice = 'addNotificationDevice',
  RemoveNotificationDevice = 'removeNotificationDevice',
  EditDealAffiliationRequest = 'editDealAffiliationRequest',
  RequestDealAffiliation = 'requestDealAffiliation',
  EditListingAssignedAgent = 'editListingAssignedAgent',
  AcceptConsents = 'acceptConsents',
  RemoveMarketingConsent = 'removeMarketingConsent',
  UpdateOffice = 'publicUpdateRealEstateOffice',
  UpdateOfficeStaffMembers = 'publicUpdateRealEstateOfficeStaffMembers',
  CreateRealEstateAgent = 'publicCreateRealEstateAgent',
  UpdateRealEstateAgent = 'publicUpdateRealEstateAgent',
  PromotePrivateUserBulletin = 'promotePrivateUserBulletin',
  CancelUserPromotionPlan = 'cancelUserPromotionPlan',
  InitIframePayment = 'initIframePayment',
  InitHostedFieldsPayment = 'initHostedFieldsPayment',
  MarkHostedFieldsPaymentIntentSubmitted = 'markHostedFieldsPaymentIntentSubmitted',
  GenerateEmailVerificationCode = 'generateEmailVerificationCode',
  VerifyEmailVerificationCode = 'verifyEmailVerificationCode',
  UpdateInvestorPreferences = 'updateInvestorPreferences',
  SaveInvestorRecentSearches = 'saveInvestorRecentSearches',
  InvestorsFeedback = 'investorsFeedback',
  RedeemPhonePromotionPlanGrant = 'redeemPhonePromotionPlanGrant',
  SendAgentRequest = 'sendAgentRequest',
  DisableRecoveryEmails = 'disableRecoveryEmails',
}

export interface ILocation {
  line: number;
  column: number;
}

export enum AuthError {
  LoginFailed = 'login-failed',
  EmailAlreadyExist = 'email-already-exists',
  InvalidRegistrationType = 'invalid-registration-type',
  NeedPassword = 'need-password',
  NeedPasswordReset = 'need-password-reset',
  NoNeedToRegister = 'no-need-to-register',
  InvalidAgentRegistration = 'invalid-agent-registration',
  DeletedUser = 'Deleted user with same email',
  ConfirmConsentsV2 = 'User must approve terms and conditions',
  NeedEmailVerificationError = 'Email verification is required',
}

export enum InvalidRegistrationType {
  Email = 'email-already-exists',
  Native = 'native-already-exists',
  Facebook = 'facebook-already-exists',
  Google = 'google-already-exists',
}

export interface IError extends GraphQLError {
  email: string;
  reason: AuthError;
  message: InvalidRegistrationType;
  locations: ILocation[];
  arguments: any;
  queryPath: string[];
}

export interface LoginResponse {
  user: User;
  token: string;
  signedUp: boolean;
}

type LoginQueryResponseNG<T extends string> = {
  [key in T]: LoginResponseNG;
};

export interface IFacebookLoginVariables {
  fbUserId: string;
  email: string;
  accessToken: string;
  consents?: IConsent[];
  loginSource?: string;
}

export interface IAppleLoginVariables {
  code: string;
  redirectUri?: string;
  loginSource?: string;
  clientId?: string;
  phone?: string;
  consents?: IConsent[];
}

export interface ICompleteAppleLoginVariables {
  token: string;
  consents?: IConsent[];
}

export interface IGoogleLoginVariables {
  idToken: string;
  consents?: IConsent[];
  clientId?: string;
  loginSource?: string;
}

export interface ILoginWithEmailAndPasswordVariables {
  email: string;
  password: string;
  consents?: IConsent[];
  loginSource?: string;
}

export enum ConsentType {
  TC = 'termsAndConditions',
  Marketing = 'marketing',
}

export interface IConsentData {
  type: ConsentType;
  approval: boolean;
}

export enum ConsentTypeNG {
  MARKETING = 'MARKETING',
  TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS',
  LEAD_TERMS_AND_CONDITIONS = 'LEAD_TERMS_AND_CONDITIONS',
  LISTING_UPLOAD_TERMS_AND_CONDITIONS = 'LISTING_UPLOAD_TERMS_AND_CONDITIONS',
  INVESTORS_TERMS_AND_CONDITIONS = 'INVESTORS_TERMS_AND_CONDITIONS',
}

export enum EmailVerificationCodeStatus {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  BLOCKED = 'BLOCKED',
}

export interface IConsent {
  type: ConsentTypeNG;
  approval: boolean;
}

export interface ISignInSignUpWithEmailVariables {
  email: string;
  userToken?: string;
  consents?: IConsent[];
}

export type AuthEventMethod = SocialVendor | 'native';

export interface IUserAuthEventDataVariables {
  source?: AuthModalSource;
  signUpMethod?: AuthEventMethod;
  signInMethod?: AuthEventMethod;
  emailAddress?: string;
}

export interface IGenerateEmailVerificationCodeVariables {
  email: string;
  userToken?: string;
}

export interface IVerifyEmailVerificationCodeVariables {
  email: string;
  code: string;
  userToken?: string;
}

export interface IResetPasswordUpdateResponse {
  resetPasswordUpdate?: {
    status: ResetPasswordStatus;
  };
}

export interface IGenerateEmailVerificationCodeResponse {
  generateEmailVerificationCode: {
    statusCode: EmailVerificationCodeStatus;
    remainedTtl: number;
    remainedRetries: number;
  };
}

export interface IverifyEmailVerificationCodeResponse {
  verifyEmailVerificationCode: {
    statusCode: EmailVerificationCodeStatus;
    remainedTtl: number;
    remainedRetries: number;
    remainedSends: number;
    isTermsAndConditionsAccepted: boolean;
    token: string;
  };
}

export interface IResetPasswordUpdateVariables {
  token: string;
  newPassword: string;
  consents?: IConsent[];
  email?: string;
}

export interface IUpdateUserProfileVariables {
  commutePreference?: CommutePreference;
  firstName?: string;
  lastName?: string;
  phone?: string;
  userInfo?: {
    moveIn?: MoveIn;
  };
}

export interface IFormFields {
  name?: string;
  message: string;
  phone: string;
  email?: string;
}

export interface UgcTextReviewEntry {
  topic: Topic.TextReview | Topic.UpgradeRequest;
  textReview: string;
}

export interface UgcRatingReviewEntry {
  topic: RatingTopic;
  numericReview: number;
}

export type InputUGCEntry = UgcTextReviewEntry | UgcRatingReviewEntry;

export interface UGCEmotionsEntryByUser {
  emotions: number[];
  userEmotion: number;
}

export interface IUserTextReviewResponse {
  date: string;
  photo: string;
  textReview: string;
  topic: Topic.TextReview;
  ugcId: string;
  userName: string;
  emotions: UGCEmotionsEntryByUser | null;
}

interface IRatingReviewProps {
  numericReview: number;
  topic: RatingTopic;
}

export interface IUserRatingReviewResponse {
  basedOn: number;
  reviews: IRatingReviewProps[];
}

export interface AddUGCVariables {
  docId: string;
  email?: string;
  name?: string;
  numericUserInput: UgcRatingReviewEntry[];
  textUserInput: UgcTextReviewEntry[];
  userToken?: string;
}

export interface AddUGCEmotionVariables {
  isAddEmotion: boolean;
  ugcId: string;
  userEmotion: number;
  userToken?: string;
}

interface FeedbackUGCVariables {
  ugcId: string;
  address: string;
  email: string;
  feedback?: string;
  feedbackType?: string;
  message: string;
}

interface SaveUserDataVariables {
  priorities: Priority[];
  purchasePurpose: PurchasingReason;
  userToken?: string;
  docId: string;
  filters?: InputSavedSearchQuery;
}

interface InputSavedSearchQuery {
  dealType: DealType;
  roomsRange: RangeTuple<RoomOption>;
  priceRange: RangeTuple<number>;
  amenities: Partial<Record<Amenity, boolean>>;
}

export interface ContactV4Variables {
  poiId?: string;
  phone: string;
  message?: string;
  type: LeadType;
  userToken?: string;
  additionalData?: AdditionalData;
  name?: string;
  email?: string;
  refererId?: {
    id: string;
    type: string;
  };
  leadTermsAccepted?: boolean;
}

export interface ContactV4MortgageOfficeVariables {
  poiId: string;
  phone: string;
  type: LeadType;
  userToken?: string;
  additionalData?: {
    officeEmail?: string;
    officeName?: string;
  };
  name?: string;
  email?: string;
  leadTermsAccepted?: boolean;
}

export enum AdditionalDataPageType {
  NewOfficePage = 'newOfficePage',
  NewAgentPage = 'newAgentPage',
}

interface AdditionalData {
  dealType: DealType;
  amenities: Partial<Record<Amenity, boolean>>;
  priceRange: RangeTuple<number>;
  roomsRange: RangeTuple<RoomOption>;
  purchasePurpose: PurchasingReason;
  docId: string;
  officeEmail?: string;
  officeName?: string;
  pageType?: AdditionalDataPageType;
}

export enum LeadType {
  Project = 'project',
  Bulletin = 'bulletin',
  CommercialProject = 'commercialProject',
  CommercialBulletin = 'commercialBulletin',
  Ad = 'ad',
  Deal = 'deal',
  AccompanyingPurchasers = 'accompanyingPurchasers',
  Office = 'realEstateOffice',
  Agent = 'realEstateAgent',
  MortgageConsult = 'mortgageConsult',
  MortgageOffice = 'mortgageAdvisorsOffice',
}

export interface ISaveSearchQueryProp {
  dealType: DealType;
  location: IReference;
  amenities: Partial<Record<Amenity, boolean>>;
  areaRange: RangeTuple<number>;
  monthlyTaxRange: RangeTuple<number>;
  bathsRange: RangeTuple<BathOption>;
  generalCondition: Condition[];
  noFee: boolean;
  floorRange: RangeTuple<number>;
  priceRange: RangeTuple<number>;
  ppmRange: RangeTuple<number>;
  buildingClass: PropertyType[];
  roomsRange: RangeTuple<RoomOption>;
  sellerType: Seller[];
  notificationsCount?: number;
  secureRoomType?: SecureRoomType;
}


export interface ISaveSearchFromState {
  title?: string;
  term?: string;
  query?: ISaveSearchQueryProp;
  locationDocIds?: string[];
  searchType?: string;
}

export interface ISaveSearch extends ISaveSearchFromState {
  updateFrequency: UpdateFrequency;
  searchId: string;
  notificationsCount?: number;
  searchPreviews?: IImageItem[];
}

export interface IAgentInOffice {
  agentName: string;
  userId: string;
  agentId: string;
  officeId?: string;
  officeName?: string;
}

export enum IAgentStatusType {
  Approved = 'approved',
  Unapproved = 'unapproved',
}

export enum PricingTier {
  Standard = 'standard',
  Discounted = 'discounted',
}

export enum PricingTierApi3 {
  Standard = 'STANDARD',
  Discounted = 'DISCOUNTED',
}

export interface IAgentStatus {
  agentId: string;
  officeId: string;
  status: IAgentStatusType;
  displayLevel: IOfficeAgentDisplayLevel;
  pricingTier: PricingTier;
}

interface AddUGCResponse {
  addUgc: boolean;
}

export interface ContactV4Response {
  contactV4: {
    lead: {
      leadId: string;
    };
  };
}

interface AddUGCEmotionResponse {
  addUgcEmotion: {
    emotions: number[];
    userEmotion?: number;
  };
}

interface FeedbackUGCResponse {
  feedbackV2: boolean;
}

export type IUpdateSaveSearch = Pick<ISaveSearch, 'searchId' | 'updateFrequency' | 'term' | 'locationDocIds' | 'query' | 'title'>;
export type IUpdateSaveSearchFrequency = Pick<ISaveSearch, 'searchId' | 'updateFrequency' | 'term'>;

export interface ISaveSearchQueryVariables {
  search: Partial<ISaveSearch>;
}

export interface IDeleteSaveSearchQueryVariables {
  searchId: string;
}

export interface IContactPageSubmitVariables {
  id?: string;
  email?: string;
  message?: string;
  isMortgageConsult?: boolean;
  name?: string;
  phone: string;
  type: LeadType | PoiType;
  userToken?: string;
  additionalData?: AdditionalData;
  refererId?: {
    id: string;
    type: string;
  };
  eventSource?: ContactAgentModalSource;
  source?: ContactAgentModalSource;
  leadTermsAccepted?: boolean;
}

export interface IContactPageSubmitResponse {
  contactV4: {
    lead: {
      leadId: string;
    },
  };
}

export interface IFavorites {
  favorites: IPoiIdentifier[];
}

export interface IFavoritesToggle extends IFavorites {
  isFavorite: boolean;
}

export interface IFavoritesToggleMeta {
  source?: string;
}

export interface ILastViewedVariables {
  lastViewed: IPoiIdentifier[];
}

export interface BadAddressReportVariables {
  docId?: string;
  remarks?: string;
  extraData?: {
    reportSource?: UploadBulletinReportSource;
    dealType?: DealType;
    id?: PoiId;
    message?: string;
    email?: string;
  };
}

export interface IContactAgentVariables {
  contactId: IPoiIdentifier;
}

export interface IContactAgentResponse {
  addContactAgent: DatedPoi[];
}

export interface ISendFeedbackVariables {
  insightType: InsightDescriptor;
  insightRecordId: string;
  message: string;
  bulletinId?: string;
  address?: string;
  feedback?: string;
  feedbackType?: FeedbackPopupType;
  email?: string;
  sourceType: SourceType;
}

export interface ISendFeedbackResponse {
  feedback: boolean;
}

export interface SavedAddressSettings {
  insightsUpdates: boolean;
  isHome: boolean;
  newListingUpdates: boolean;
}

export interface ISavedAddressToggle extends SavedAddress {
  isSaved: boolean;
  isChanged?: boolean;
}

export type ToggleAddressTriggers =
  'follow_address_sticky'
  | 'impact_card'
  | 'impact_empty_card'
  | 'insight_expand'
  | 'follow_address_form'
  | 'impact_card_bell'
  | 'user_generated_content';

export interface ToggleAddressMeta {
  source: ToggleAddressTriggers;
}

export interface IDeleteAddressVariables {
  docId: string;
}

export interface ISavedSearchUnsubscribeVariables {
  token: string;
  unsubscribe: boolean;
}

export interface IUnsubscribeFromSavedSearchesVariables {
  token: string;
  unsubscribeAll: boolean;
  isProjectEmail: boolean;
  removeMarketingConsents: boolean;
}

export interface IUndoUnsubscribeFromSavedSearchesVariables {
  stateId: string;
}

export interface IEditBulletinStatusVariables {
  bulletinId: PoiId;
  userToken?: string;
  status: {
    status: ListingStatusType,
    promoted: boolean,
    message: string,
  };
}

export interface LoginPersonalAssistantVariables {
  userToken?: string;
  phoneNumber: string;
}

type GlobalErrors = 'overTheCreditLimit' | 'masAddressFailure' | 'generalFailure';

export interface LoginPersonalAssistantResponse {
  signedUp: boolean;
  errorList: string[];
}

export interface IEditBulletinStatusResponse {
  editBulletinStatus: {
    bulletin: {
      id: PoiId;
      status: {
        status: BulletinStatusType,
      },
    },
    errorCodes?: GlobalErrors[];
    saved: boolean;
  };
}

export interface ISavedSearchUnsubscribeResponse {
  updatePriorities: boolean;
}

export type SaveBulletinErrorCodes = 'overTheCreditLimit' | 'maskAddressFailure' | 'generalFailure';

export interface SavedAddress {
  docId: string;
  settings?: SavedAddressSettings;
}

export enum ListingResponseType {
  NoPermissionsError = 'NoPermissionsError',
  GeneralListingError = 'GeneralListingError',
  UserCannotAddListingError = 'UserCannotAddListingError',
  InvalidInputError = 'InvalidInputError',
  SuccessfulListingsResponse = 'SuccessfulListingsResponse',
  SuccessfulListingValidation = 'SuccessfulListingValidation',
}
export enum UserCannotAddListingErrorField {
  UserId = 'USER_ID',
  PhoneNumber = 'PHONE_NUMBER',
}

export interface IUserListingResponseError {
  errorMessage?: string;
  invalidField?: string;
  field?: UserCannotAddListingErrorField;
}

export interface UpdateListingResponse {
  id: PoiId;
  agentId: string;
  status: {
    status: BulletinStatusType;
    promoted: boolean;
  };
}

export interface SuccessfulListingValidation {
  __typename: ListingResponseType.SuccessfulListingValidation;
  field?: UserCannotAddListingErrorField;
  valid: boolean;
}

export interface NoPermissionsError {
  __typename: ListingResponseType.NoPermissionsError;
  field?: UserCannotAddListingErrorField;
  errorMessage: string;
}

export interface GeneralListingError {
  __typename: ListingResponseType.GeneralListingError;
  field?: UserCannotAddListingErrorField;
  errorMessage: string;
}

export interface UserCannotAddListingError {
  __typename: ListingResponseType.UserCannotAddListingError;
  errorMessage: string;
  field: UserCannotAddListingErrorField;
}

export interface InvalidInputError {
  __typename: ListingResponseType.InvalidInputError;
  field?: UserCannotAddListingErrorField;
  errorMessage: string;
  invalidField: string;
}

export type ListingValidationResult =
  | SuccessfulListingValidation
  | NoPermissionsError
  | GeneralListingError
  | UserCannotAddListingError
  | InvalidInputError;

export interface NewListingValidationResponse {
  newListingValidation: ListingValidationResult;
}

export interface EditListingValidationResponse {
  editListingValidation: ListingValidationResult;
}


export interface INewListingResponse extends IUserListingResponseError {
  listing: UpdateListingResponse;
  __typename: ListingResponseType;
}

export type IEditListingResponse = INewListingResponse;

export interface INewCommercialListingResponse extends IUserListingResponseError {
  commercialListing: UpdateListingResponse;
  __typename: ListingResponseType;
}

export interface IEditListingPromotionResponse {
  id: string;
  promoted: boolean;
}

export type IEditCommercialListingResponse = INewCommercialListingResponse;

export interface IListingStatusUpdate {
  id: PoiId;
  agentId: string;
  status: {
    status: BulletinStatusType;
  };
}

export interface IEditListingStatusResponse {
  listing: IListingStatusUpdate;
  errors: Array<{errorMessage: string}>;
}

export interface IEditCommercialListingStatusResponse {
  commercialListing: IListingStatusUpdate;
  errors: Array<{errorMessage: string}>;
}

export interface ITempTokenAuthVariables {
  loginToken: string;
}

export interface MadadResponse {
  madad: MadadDto[];
}

export interface HPSlideFIle {
  url: string;
  title: string;
}

export enum SlideType {
  Desktop = 'desktop',
  Mobile = 'mobile',
}

export type SlideStatus = 'publish' | 'draft';

export interface AsideCSSDate {
  maxWidth: number;
  transformX: number;
  transformY: number;
}

export interface HPBaseSlide {
  id: string;
  slideType: SlideType;
  status: SlideStatus;
  navigation: {
    text: string;
    link: string;
  };
  aside: {
    link: string;
    file: HPSlideFIle;
    imageCssProps?: AsideCSSDate;
  };
}

export interface HPSlide extends HPBaseSlide {
  title: string;
  subtitle: string;
  backgroundFile: HPSlideFIle;
}

export type HPBanner = { id: 'hp-banner' } & Record<SlideType, HPSlide[]>;

export interface HPBannerResponse {
  homePageBanner: HPBanner;
}

export interface IProjectMapLogo {
  id: PoiId;
  logo: {
    title: string;
    url: string;
  };
}

export interface ProjectMapLogoResponse {
  data:  IProjectMapLogo[];
}

export enum PhoneValidationStatus {
  Success = 'SUCCESS',
  Failure = 'FAILURE',
  Blocked = 'BLOCKED',
}

export interface DeveloperByIdResponse {
  developerById: IDeveloperProfile;
}

export interface OfficeByIdResponse {
  getRealEstateOfficeById: IOfficePageData;
}

export interface OfficeDataByIdResponse {
  getRealEstateOfficeById: IOfficeData;
}

export interface OfficeBulletinsByIdResponse {
  getRealEstateOfficeById: IAgentOfficeBulletinsData;
}

export interface AgentBulletinsByIdResponse {
  getRealEstateAgentById: IAgentOfficeBulletinsData;
}

export interface AgentByIdResponse {
  getRealEstateAgentById: IAgentPageData;
}

export interface AgentWithBulletinsByIdResponse {
  getRealEstateAgentById: IAgentWithBulletinsData;
}

export interface TeamByOfficeIdResponse {
  getPublicRealEstateAgentsByOfficeId: ITeamByOfficeIdData[];
}

interface IDevelopersWithPromotedProjectsResponse {
  developersAndPromotedProjects: {
    developers: IDeveloperProfile[];
    poi: Array<ICommercialProject | IProject>;
  };
}

export type ISearchDeveloper = Pick<IDeveloperProfile, 'id' | 'name' | 'logoUrl' | 'images' | 'projectsCount' | 'integrationLevel'>;

export interface SearchDevelopersResponse {
  searchDevelopersIndex: {
    totalCount: number;
    developers: ISearchDeveloper[];
  };
}

export interface MortgagOfficesByCityDocIdsResponse {
  getPublicMortgageAdvisorsOfficesByCityDocIds: {
    total: number;
    offices: IMortgageOffice[];
  };
}
export interface MortgageOfficeByIdResponse {
  getPublicMortgageAdvisorsOfficesByIds: {
    offices: IMortgageOffice[];
  };
}

export interface OfficeListingsResponse {
  getOfficeListings: {
    commercial: ICommercialBulletin[];
    residential: IBulletin[];
  };
}

export interface GetDealsAffiliationRequestsResponse {
  getDeals: {
    deals: IDealAffiliationRequest[];
    total: number;
  };
}

export interface GetResidentialAndCommercialListingsResponse {
  getResidentialAndCommercialListings: {
    listings: Array<{ bulletin?: IBulletin, commercialBulletin?: ICommercialBulletin }>;
    total: number;
  };
}

export interface SearchDealsResponse {
  searchDeals: {
    result: ISearchDeal[];
    total: number;
  };
}

export interface GetDealAffiliationRequestsBySaleIdResponse {
  getDealAffiliationRequestBySaleId:  {
    results: IRequestDealAffiliationResponse[];
  };
}

export interface GetCommercialListingResponse {
  getCommercialListing: ICommercialListing;
}

export interface GetResidentialListingResponse {
  getResidentialListingById: {
    listing: IBulletin;
  };
}

export type BusRoute = GeoJSON.Feature<GeoJSON.MultiLineString, unknown>;

export interface BusRouteByIdsResponse {
  busRouteByIds: BusRoute[];
}

export interface ListingSearchDataError {
  errorMessage: string;
  __typename: 'ListingSearchDataError';
}

export interface ListingSearchDataResponse {
  listingSearchData: ListingSearchData | ListingSearchDataError;
}

interface ISubmitContactMadlanLeadVariables {
  leadInput: IContactMadlanLead;
}

export interface IContactMadlanLead {
  productId: ContactMadlanReason;
  email: string;
  phone?: string;
  name: string;
  sourceUrl: string;
  formContactData: IFormContactData;
}

export enum ContactMadlanReason {
  GeneralConnectUs = 'generalConnectUs',
  Job = 'job',
  MailingListHelp = 'mailingListHelp',
  BulletinError = 'bulletinError',
  LoginHelp = 'loginHelp',
  FindPropertyHelp = 'findPropertyHelp',
  NeigHelp = 'neigHelp',
  SoldHelp = 'soldHelp',
  ErrorReport = 'errorReport',
  Promotion = 'promotion',
  DevProTools = 'devProTools',
  RealEstateAgentProTools = 'realEstateAgentProTools',
  EducationHelp = 'educationHelp',
}

export interface IFormContactData {
  officeName?: string;
  errorDetails?: string;
  details?: string;
  cityOfActivity?: string;
  numberOfAgentsInOffice?: string;
  companyName?: string;
  role?: string;
}

export interface SubmitContactMadlanLeadResponse {
  submitContactMadlanLead: string;
}

export interface DeveloperLeadVariables {
  name: string;
  email: string;
  phone: string;
  contactReason: ContactDeveloperReason;
  developerId: string;
}

export interface SubmitDeveloperLeadVariables {
  data: DeveloperLeadVariables;
}

interface ArticleSearchArgument {
  docIds: string[];
  marketplaceType?: string;
}

export interface GetArticlesVariables {
  query: ArticleSearchArgument;
}

export interface IEditDealAffiliationRequestVariables {
  input: {
    id: string;
    agentId: string;
    agentType: DealAffiliationType;
    receiptUrls: string[];
  };
}

export interface IRequestDealAffiliationVariables {
  input: {
    soldId: string;
    agentId: string;
    agentType: DealAffiliationType;
    receiptUrls: string[];
  };
}

export interface SubmitDeveloperLeadResponse {
  submitDeveloperLead: string;
}

export interface ArticleOwner {
  id: string;
  name: string;
}

export interface Article {
  id: string;
  title: string;
  owner: ArticleOwner;
  image: string;
  link: string;
}

export interface GetArticlesResponse {
  getArticles: Article[];
}

export enum DeregisterUserStatus {
  DEREGISTER_USER_SUCCESS = 'DEREGISTER_USER_SUCCESS',
  DEREGISTER_USER_FAILURE = 'DEREGISTER_USER_FAILURE',
  DEREGISTER_USER_NO_USER = 'DEREGISTER_USER_NO_USER',
}

export interface DeregisterUserResponse {
  deregisterUser: {
    user: {
      userId: string;
    };
    status: DeregisterUserStatus;
  };
}

export interface EditDealAffiliationRequestResponse {
  publicEditDealAffiliationRequest: IAffiliationRequestResponseDeal;
}

export interface RequestDealAffiliation {
  requestDealAffiliation: IRequestDealAffiliationResponse;
}

export interface Cursor {
  bulletinsOffset?: number;
  projectsOffset?: number;
  seenProjects?: string[];
}

export interface IAcceptConsentsResponse {
  success: boolean;
  errorMessage: string;
}

export interface IRemoveMarketingConsentResponse {
  success: boolean;
  errorMessage: string;
}

export interface IPromotePrivateUserBulletinResponse {
  success: boolean;
  errorMessage?: string;
}

export interface ICancelUserPromotionPlanResponse {
  success: boolean;
  errorMessage?: string | null;
}

export interface IFramePayment {
  iframeUrl: string;
  paymentId: string;
}

export interface IHostedFieldsPayment {
  paymentId: string;
  amount: number;
  currencyCode: string;
  thtk: string;
  notifyUrl: string;
  terminalName: string;
  productDescription: string;
}

interface IInvestorFavoriteNeighbourhoodResponse {
  success: boolean;
  message?: string;
}

interface RedeemPhonePromotionPlanGrantResponse {
  success: boolean;
  errorCode?: string | null;
}

export interface MutationResponseByType {
  [MutationType.AddInvestorFavoriteNeighbourhood]: {
    addInvestorFavoriteNeighborhood: IInvestorFavoriteNeighbourhoodResponse;
  };
  [MutationType.RemoveInvestorFavoriteNeighbourhood]: {
    removeInvestorFavoriteNeighborhood: IInvestorFavoriteNeighbourhoodResponse;
  };
  [MutationType.UpdateRealEstateAgent]: {
    publicUpdateRealEstateAgent: { agentId: string };
  };
  [MutationType.CreateRealEstateAgent]: {
    publicCreateRealEstateAgent: IPublicRealEstateAgent;
  };
  [MutationType.UpdateOfficeStaffMembers]: {
    publicUpdateRealEstateOfficeStaffMembers: IOfficeByIdData;
  };
  [MutationType.UpdateOffice]: {
    publicUpdateRealEstateOffice: IOfficeByIdData;
  };
  [MutationType.FacebookLogin]: LoginQueryResponseNG<'facebookLogin'>;
  [MutationType.AppleLogin]: LoginQueryResponseNG<'appleLogin'>;
  [MutationType.CompleteAppleLogin]: LoginQueryResponseNG<'completeAppleLogin'>;
  [MutationType.GoogleLogin]: LoginQueryResponseNG<'googleLogin'>;
  [MutationType.SignInSignUpWithEmail]: LoginQueryResponseNG<'loginV3'>;
  [MutationType.LoginWithEmailAndPassword]: LoginQueryResponseNG<'passwordLoginV3'>;
  [MutationType.TempTokenAuth]: LoginQueryResponseNG<'completeAutoLogin'>;
  [MutationType.RegisterVisitor]: LoginQueryResponseNG<'registerVisitor'>;
  [MutationType.ResetPasswordUpdate]: IResetPasswordUpdateResponse;
  [MutationType.GenerateEmailVerificationCode]: IGenerateEmailVerificationCodeResponse;
  [MutationType.VerifyEmailVerificationCode]: IverifyEmailVerificationCodeResponse;
  [MutationType.UpdateUserProfile]: {
    updateUserProfile: User;
  };
  [MutationType.ContactPageSubmit]: IContactPageSubmitResponse;
  [MutationType.AgentOfficeContactPageSubmit]: IContactPageSubmitResponse;
  [MutationType.AddFavorites]: {
    addFavorites: DatedPoi[];
  };
  [MutationType.RemoveFavorites]: {
    removeFavorites: DatedPoi[];
  };
  [MutationType.AddContactAgent]: IContactAgentResponse;
  [MutationType.AddRecentlyViewed]: {
    addRecentlyViewed: DatedPoi[];
  };
  [MutationType.SendFeedback]: ISendFeedbackResponse;
  [MutationType.SaveSearchQuery]: IUpdateSaveSearchResponse;
  [MutationType.UpdateSearchQuery]: IUpdateSaveSearchResponse;
  [MutationType.DeleteSaveSearch]: IDeleteSaveSearchResponse;
  [MutationType.SaveAddress]: {
    saveAddress: UserSavedAddresses[],
  };
  [MutationType.DeleteAddress]: {
    deleteAddress: UserSavedAddresses[],
  };
  [MutationType.SavedSearchUnsubscribe]: ISavedSearchUnsubscribeResponse;
  [MutationType.UnsubscribeFromSavedSearches]: { unsubscribeFromSavedSearches: string; };
  [MutationType.UndoUnsubscribeFromSavedSearches]: { undoUnsubscribeFromSavedSearches: boolean; };
  [MutationType.NewListing]: { newListing: INewListingResponse };
  [MutationType.NewListingValidation]: NewListingValidationResponse;
  [MutationType.EditListing]: { editListing: IEditListingResponse };
  [MutationType.EditListingValidation]: EditListingValidationResponse;
  [MutationType.EditListingStatus]: { editListingStatus: IEditListingStatusResponse };
  [MutationType.EditListingPromotionStatus]: { editListingPromotionStatus: IEditListingPromotionResponse; };
  [MutationType.NewCommercialListing]: { newCommercialListing: INewCommercialListingResponse };
  [MutationType.EditCommercialListing]: { editCommercialListing: IEditCommercialListingResponse };
  [MutationType.EditCommercialListingStatus]: { editCommercialListingStatus: IEditCommercialListingStatusResponse };
  [MutationType.EditCommercialListingAssignedAgent]: { editAssignedAgentCommercialListing: IEditCommercialListingResponse; };
  [MutationType.EditListingAssignedAgent]: { editAssignedAgentListing: IEditListingResponse; };
  [MutationType.EditCommercialListingPromotionStatus]: { editCommercialListingPromotionStatus: IEditCommercialListingResponse; };
  [MutationType.UploadBulletinBadAddressReport]: {
    badAddressReport: boolean;
  };
  [MutationType.EditBulletinStatus]: IEditBulletinStatusResponse;
  [MutationType.SaveRecentSearch]: {
    saveRecentSearch: ISaveSearch,
  };
  [MutationType.AddUGC]: AddUGCResponse;
  [MutationType.AddUGCEmotion]: AddUGCEmotionResponse;
  [MutationType.FeedbackUGC]: FeedbackUGCResponse;
  [MutationType.SaveUserData]: {
    SaveUserData: boolean;
  };
  [MutationType.ContactV4]: ContactV4Response;
  [MutationType.ContactV4MortgageOffice]: ContactV4Response;
  [MutationType.LoginPersonalAssistant]: LoginPersonalAssistantResponse;
  [MutationType.GenerateValidationCode]: {
    generateValidationCode: PhoneValidationStatus;
  };
  [MutationType.CheckValidationCode]: {
    checkValidationCode: PhoneValidationStatus;
  };
  [MutationType.SubmitContactMadlanLead]: SubmitContactMadlanLeadResponse;
  [MutationType.SubmitDeveloperLead]: SubmitDeveloperLeadResponse;
  [MutationType.GetArticles]: GetArticlesResponse;
  [MutationType.DeregisterUser]: DeregisterUserResponse;
  [MutationType.AddNotificationDevice]: {
    addNotificationDevice: UserNotificationDevice;
  };
  [MutationType.RemoveNotificationDevice]: {
    removeNotificationDevice: UserNotificationDevice;
  };
  [MutationType.EditDealAffiliationRequest]: EditDealAffiliationRequestResponse;
  [MutationType.RequestDealAffiliation]: RequestDealAffiliation;
  [MutationType.AcceptConsents]: { acceptConsents: IAcceptConsentsResponse };
  [MutationType.RemoveMarketingConsent]: { removeMarketingConsent: IRemoveMarketingConsentResponse };
  [MutationType.PromotePrivateUserBulletin]: { promotePrivateUserBulletin: IPromotePrivateUserBulletinResponse };
  [MutationType.CancelUserPromotionPlan]: { cancelUserPromotionPlan: ICancelUserPromotionPlanResponse };
  [MutationType.InitIframePayment]: { initIframePayment: IFramePayment };
  [MutationType.InitHostedFieldsPayment]: { initHostedFieldsPayment: IHostedFieldsPayment };
  [MutationType.MarkHostedFieldsPaymentIntentSubmitted]: { markPaymentIntentSubmitted: boolean };
  [MutationType.UpdateInvestorPreferences]: { updateInvestorPreferences: { success: boolean } };
  [MutationType.SaveInvestorRecentSearches]: { success: boolean };
  [MutationType.SubmitLead]: { submitLead: string; };
  [MutationType.InvestorsFeedback]: { investorsFeedback: { success: boolean; errorMessage: string } };
  [MutationType.RedeemPhonePromotionPlanGrant]: { redeemPromotionPlanGrant: RedeemPhonePromotionPlanGrantResponse };
  [MutationType.SendAgentRequest]: { sendAgentRequest: boolean };
  [MutationType.DisableRecoveryEmails]: { disableRecoveryEmails: boolean };
}

interface AddNotificationDeviceVariables {
  deviceToken: string;
  deviceType: DeviceType;
}

export enum RemoveNotificationDeviceReason {
  INVALIDATED_BY_PROVIDER = 'INVALIDATED_BY_PROVIDER',
  LOGGED_OUT = 'LOGGED_OUT',
  MANUALLY_DISABLED = 'MANUALLY_DISABLED',
}

interface RemoveNotificationDeviceVariables {
  deviceToken: string;
  deleteReason: RemoveNotificationDeviceReason;
}

export enum IConsentType {
  MARKETING = 'MARKETING',
  TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS',
  LEAD_TERMS_AND_CONDITIONS = 'LEAD_TERMS_AND_CONDITIONS',
  LISTING_UPLOAD_TERMS_AND_CONDITIONS = 'LISTING_UPLOAD_TERMS_AND_CONDITIONS',
  INVESTORS_TERMS_AND_CONDITIONS = 'INVESTORS_TERMS_AND_CONDITIONS',
}

interface IAcceptConsentsVariables {
  input: {
    consents: IConsentType[];
    unsubscribeMarketingToken?: string;
    source?: string;
  };
}

interface IRemoveMarketingConsentVariables {
  input: {
    unsubscribeToken: string;
    source?: string;
  };
}

export interface IUpdateOfficeVariables {
  office: {
    officeId: string;
    iconUrl: string;
    descriptionHtml: string;
    spotlightListings: ISpotlightListing[];
    websiteUrl: string;
    facebookPageUrl: string;
    instagramUrl: string;
    linkedinUrl: string;
    videoUrl: string;
    videoSource?: IRealEstateVideoSource;
    officeDetailsInBulletins: boolean;
    officeConnectionInAgentPage: boolean;
    allOfficeBulletinsInAgentPage: boolean;
  };
}

export interface IUpdateOfficeStaffMembersVariables {
  officeId: string;
  staffMembers: IStaffMember[];
}

export interface ICreateRealEstateAgentVariables {
  agent: {
    officeId: string;
    name: string;
    phone1: string;
    licenseId: string;
    emailAddress: string;
    licenseFromYear?: string;
    iconUrl?: string;
    descriptionHtml?: string;
  };
}

export interface IUpdateRealEstateAgentVariables {
  agent: {
    agentId: string;
    officeId: string;
    iconUrl?: string;
    descriptionHtml?: string;
    websiteUrl?: string;
    facebookPageUrl?: string;
    instagramUrl?: string;
    linkedinUrl?: string;
    videoUrl?: string;
    videoSource?: IRealEstateVideoSource;
    spotlightListings?: ISpotlightListing[];
    testimonials?: IRealEstateAgentTestimonial[];
  };
}
interface IPromotePrivateUserBulletinVariables {
  input: {
    bulletinId: string;
    bulletinType: string; // 'COMMERCIAL' or 'RESIDENTIAL'
    source: string;
  };
}

interface ICancelUserPromotionPlanVariables {
  userPromotionPlanId: string;
  reason?: string;
  userToken?: string;
}

interface InitIframePaymentInput {
  productId: string;
  redirectUrl: string;
  contactName: string;
  phone: string;
  bulletinsIds?: string[];
}

interface IInitIframePaymentVariables {
  userToken?: string;
  input: InitIframePaymentInput;
}

interface InitHostedFieldsPaymentInput {
  productId: string;
  contactName?: string;
  phone?: string;
  bulletinsIds?: string[];
  method?: TranzilaPaymentMethod;
}

interface IInitHostedFieldsPaymentVariables {
  userToken?: string;
  input: InitHostedFieldsPaymentInput;
}

interface IMarkHostedFieldsPaymentIntentSubmittedVariables {
  userToken?: string;
  paymentId: string;
  isSubmitted: boolean;
  bulletinId?: string;
}

interface IInvestorPreferenceVariables {
  input: {
    budget?: number;
    placeDocIds?: string[];
    hasProperty?: number;
    goal?: string;
  };
}

interface ISaveInvestorRecentSearchesVariables {
  userToken: string;
  docIds: string[];
}

export enum LeadTypeApi3 {
  AGENT_RESIDENTIAL_BULLETIN = 'AGENT_RESIDENTIAL_BULLETIN',
  PRIVATE_RESIDENTIAL_BULLETIN = 'PRIVATE_RESIDENTIAL_BULLETIN',
  AGENT_COMMERCIAL_BULLETIN = 'AGENT_COMMERCIAL_BULLETIN',
  PRIVATE_COMMERCIAL_BULLETIN = 'PRIVATE_COMMERCIAL_BULLETIN',
  PROJECT = 'PROJECT',
  REAL_ESTATE_OFFICE = 'REAL_ESTATE_OFFICE',
  REAL_ESTATE_AGENT = 'REAL_ESTATE_AGENT',
  MORTGAGE_CONSULT = 'MORTGAGE_CONSULT',
  MADLAN_OFFER_BOOST = 'MADLAN_OFFER_BOOST',
  DEVELOPER = 'DEVELOPER',
  MIZRACHI_MORTGAGE = 'MIZRACHI_MORTGAGE',
  CONTACT_MADLAN = 'CONTACT_MADLAN',
  MORTGAGE_ADVISORS_OFFICE = 'MORTGAGE_ADVISORS_OFFICE',
}

export interface ISubmitLeadVariables {
  leadInput: {
    type: LeadTypeApi3;
    productId: string;
    email?: string;
    phone: string;
    name?: string;
    sourceUrl?: string;
    message?: string;
    leadTermsAccepted?: boolean;
    isWhatsApp?: boolean;
  };
}

export enum UserFeedbackReason {
  SUGGEST_IDEA = 'SUGGEST_IDEA',
  SOMETHING_IS_MISSING = 'SOMETHING_IS_MISSING',
  REPORT_AN_ISSUE = 'REPORT_AN_ISSUE',
}

export enum InvestorsPortalPageType {
  LOGIN = 'LOGIN',
  LOBBY = 'LOBBY',
  ONBOARDING_WIZARD = 'ONBOARDING_WIZARD',
  INVESTORS_HOMEPAGE = 'INVESTORS_HOMEPAGE',
  NEIGHBORHOOD_PAGE = 'NEIGHBORHOOD_PAGE',
  COMPARE_NEIGHBORHOODS_PAGE = 'COMPARE_NEIGHBORHOODS_PAGE',
  INVESTORS_MARKETPLACE = 'INVESTORS_MARKETPLACE',
}

export interface IInvestorsFeedbackVariables {
  input: {
    reason: UserFeedbackReason;
    message: string;
    url: string;
    investorsPageSource: InvestorsPortalPageType;
  };
}

export interface IRedeemPhonePromotionPlanGrantVariables {
  phone?: string;
}

export interface MutationVariablesByType {
  [MutationType.AddInvestorFavoriteNeighbourhood]: { docId: string };
  [MutationType.RemoveInvestorFavoriteNeighbourhood]: { docId: string };
  [MutationType.UpdateRealEstateAgent]: IUpdateRealEstateAgentVariables;
  [MutationType.CreateRealEstateAgent]: ICreateRealEstateAgentVariables;
  [MutationType.UpdateOfficeStaffMembers]: IUpdateOfficeStaffMembersVariables;
  [MutationType.UpdateOffice]: IUpdateOfficeVariables;
  [MutationType.FacebookLogin]: IFacebookLoginVariables;
  [MutationType.AppleLogin]: IAppleLoginVariables;
  [MutationType.CompleteAppleLogin]: ICompleteAppleLoginVariables;
  [MutationType.GoogleLogin]: IGoogleLoginVariables;
  [MutationType.LoginWithEmailAndPassword]: ILoginWithEmailAndPasswordVariables;
  [MutationType.RegisterVisitor]: {};
  [MutationType.SignInSignUpWithEmail]: ISignInSignUpWithEmailVariables;
  [MutationType.TempTokenAuth]: ITempTokenAuthVariables;
  [MutationType.ResetPasswordUpdate]: IResetPasswordUpdateVariables;
  [MutationType.GenerateEmailVerificationCode]: IGenerateEmailVerificationCodeVariables;
  [MutationType.VerifyEmailVerificationCode]: IVerifyEmailVerificationCodeVariables;
  [MutationType.UpdateUserProfile]: IUpdateUserProfileVariables;
  [MutationType.ContactPageSubmit]: IContactPageSubmitVariables;
  [MutationType.AgentOfficeContactPageSubmit]: IContactPageSubmitVariables;
  [MutationType.AddFavorites]: IFavorites;
  [MutationType.RemoveFavorites]: IFavorites;
  [MutationType.AddRecentlyViewed]: ILastViewedVariables;
  [MutationType.SendFeedback]: ISendFeedbackVariables;
  [MutationType.AddContactAgent]: IContactAgentVariables;
  [MutationType.SaveSearchQuery]: ISaveSearchQueryVariables;
  [MutationType.UpdateSearchQuery]: ISaveSearchQueryVariables;
  [MutationType.DeleteSaveSearch]: IDeleteSaveSearchQueryVariables;
  [MutationType.SaveAddress]: SavedAddress;
  [MutationType.DeleteAddress]: IDeleteAddressVariables;
  [MutationType.SavedSearchUnsubscribe]: ISavedSearchUnsubscribeVariables;
  [MutationType.UnsubscribeFromSavedSearches]: IUnsubscribeFromSavedSearchesVariables;
  [MutationType.UndoUnsubscribeFromSavedSearches]: IUndoUnsubscribeFromSavedSearchesVariables;
  [MutationType.NewListing]: IUploadBulletinInput;
  [MutationType.NewListingValidation]: IUploadBulletinInput;
  [MutationType.EditListing]: IUpdateListingInput;
  [MutationType.EditListingValidation]: IUpdateListingInput;
  [MutationType.NewCommercialListing]: IUploadCommercialBulletinInput;
  [MutationType.EditCommercialListing]: IUpdateCommercialListingInput;
  [MutationType.EditListingStatus]: IUpdateListingStatusInput;
  [MutationType.EditCommercialListingStatus]: IUpdateListingStatusInput;
  [MutationType.EditCommercialListingAssignedAgent]: IEditAssignedAgentCommercialListingInput;
  [MutationType.EditListingAssignedAgent]: IEditAssignedAgentListingInput;
  [MutationType.EditCommercialListingPromotionStatus]: IEditCommercialListingPromotionStatusVariables;
  [MutationType.EditListingPromotionStatus]: IEditListingPromotionStatusVariables;
  [MutationType.UploadBulletinBadAddressReport]: BadAddressReportVariables;
  [MutationType.EditBulletinStatus]: IEditBulletinStatusVariables;
  [MutationType.SaveRecentSearch]: ISaveSearchQueryVariables;
  [MutationType.AddUGC]: AddUGCVariables;
  [MutationType.AddUGCEmotion]: AddUGCEmotionVariables;
  [MutationType.FeedbackUGC]: FeedbackUGCVariables;
  [MutationType.ContactV4]: ContactV4Variables;
  [MutationType.ContactV4MortgageOffice]: ContactV4MortgageOfficeVariables;
  [MutationType.SaveUserData]: SaveUserDataVariables;
  [MutationType.LoginPersonalAssistant]: LoginPersonalAssistantVariables;
  [MutationType.GenerateValidationCode]: IGenerateValidationCodeVariables;
  [MutationType.CheckValidationCode]: ICheckValidationCodeVariables;
  [MutationType.SubmitContactMadlanLead]: ISubmitContactMadlanLeadVariables;
  [MutationType.SubmitDeveloperLead]: SubmitDeveloperLeadVariables;
  [MutationType.GetArticles]: GetArticlesVariables;
  [MutationType.DeregisterUser]: {};
  [MutationType.AddNotificationDevice]: AddNotificationDeviceVariables;
  [MutationType.RemoveNotificationDevice]: RemoveNotificationDeviceVariables;
  [MutationType.EditDealAffiliationRequest]: IEditDealAffiliationRequestVariables;
  [MutationType.RequestDealAffiliation]: IRequestDealAffiliationVariables;
  [MutationType.AcceptConsents]: IAcceptConsentsVariables;
  [MutationType.RemoveMarketingConsent]: IRemoveMarketingConsentVariables;
  [MutationType.PromotePrivateUserBulletin]: IPromotePrivateUserBulletinVariables;
  [MutationType.CancelUserPromotionPlan]: ICancelUserPromotionPlanVariables;
  [MutationType.InitIframePayment]: IInitIframePaymentVariables;
  [MutationType.InitHostedFieldsPayment]: IInitHostedFieldsPaymentVariables;
  [MutationType.MarkHostedFieldsPaymentIntentSubmitted]: IMarkHostedFieldsPaymentIntentSubmittedVariables;
  [MutationType.UpdateInvestorPreferences]: IInvestorPreferenceVariables;
  [MutationType.SaveInvestorRecentSearches]: ISaveInvestorRecentSearchesVariables;
  [MutationType.SubmitLead]: ISubmitLeadVariables;
  [MutationType.InvestorsFeedback]: IInvestorsFeedbackVariables;
  [MutationType.RedeemPhonePromotionPlanGrant]: IRedeemPhonePromotionPlanGrantVariables;
  [MutationType.SendAgentRequest]: { message: string };
  [MutationType.DisableRecoveryEmails]: { paymentIntentId: string; userToken: string };
}
